
var $25f141f40fab0fb1$export$df7cd2a2d7088cfa = /*#__PURE__*/ function(GameStates) {
    GameStates[GameStates["INTRO"] = 0] = "INTRO";
    GameStates[GameStates["EVENT"] = 1] = "EVENT";
    GameStates[GameStates["SKILLCHECK"] = 2] = "SKILLCHECK";
    GameStates[GameStates["GAME_OVER"] = 3] = "GAME_OVER";
    GameStates[GameStates["RIP"] = 4] = "RIP";
    GameStates[GameStates["LOG"] = 5] = "LOG";
    GameStates[GameStates["BAG"] = 6] = "BAG";
    GameStates[GameStates["ITEM_PICKER"] = 7] = "ITEM_PICKER";
    GameStates[GameStates["MAP"] = 8] = "MAP";
    return GameStates;
}({});


var $dc2bb2a9cc4e234e$export$6fb808e876d73c01 = /*#__PURE__*/ function(Difficulties) {
    Difficulties[Difficulties["TRIVIAL"] = 0] = "TRIVIAL";
    Difficulties[Difficulties["EASY"] = 1] = "EASY";
    Difficulties[Difficulties["MEDIUM"] = 2] = "MEDIUM";
    Difficulties[Difficulties["CHALLENGING"] = 3] = "CHALLENGING";
    Difficulties[Difficulties["VERY_HARD"] = 4] = "VERY_HARD";
    Difficulties[Difficulties["IMPOSSIBILE"] = 5] = "IMPOSSIBILE";
    return Difficulties;
}({});


class $850a1102bbecb448$export$bc2350a2190206a5 {
    constructor(canvasId){
        this.settleAnimation = null;
        this.diceElement = document.getElementById(canvasId);
        this.sceneElement = this.diceElement.closest('.dice-scene');
        this.cubeElement = this.diceElement.querySelector('.dice-cube');
        this.shadowElement = this.sceneElement.querySelector('.dice-shadow');
    }
    start() {}
    getDifficult(difficulty) {
        switch(difficulty){
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).TRIVIAL:
                return {
                    value: 1,
                    text: 'Trivial',
                    class: 'green-color-border'
                };
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).EASY:
                return {
                    value: 2,
                    text: "F\xe1cil",
                    class: 'green-color-border'
                };
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM:
                return {
                    value: 3,
                    text: "M\xe9dio",
                    class: 'green-color-border'
                };
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).CHALLENGING:
                return {
                    value: 4,
                    text: "Dif\xedcil",
                    class: 'yellow-color-border'
                };
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).VERY_HARD:
                return {
                    value: 5,
                    text: "Muito Dif\xedcil",
                    class: 'red-color-border'
                };
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).IMPOSSIBILE:
                return {
                    value: 6,
                    text: "Quase Imposs\xedvel",
                    class: 'red-color-border'
                };
        }
    }
    /**
     * Chance real de sucesso contra um valor-alvo do d6, considerando
     * as regras de crítico: 6 sempre é sucesso, 1 sempre é falha.
     */ probabilityForTarget(targetValue) {
        const successfulFaces = {
            1: 5,
            2: 5,
            3: 4,
            4: 3,
            5: 2,
            6: 1
        };
        const faces = successfulFaces[targetValue] ?? 1;
        return Math.round(faces / 6 * 100) + '%';
    }
    setFace(value) {
        for(let face = 1; face <= 6; face++)this.diceElement.classList.remove(`dice--${face}`);
        this.diceElement.classList.add(`dice--${value}`);
    }
    animateDice() {
        this.settleAnimation?.cancel();
        this.settleAnimation = null;
        this.cubeElement.style.removeProperty('transform');
        this.cubeElement.style.removeProperty('animation');
        this.shadowElement.style.removeProperty('animation');
        this.diceElement.style.setProperty('--roll-x-start', `${-35 + Math.random() * 22}deg`);
        this.diceElement.style.setProperty('--roll-y-start', `${20 + Math.random() * 60}deg`);
        this.diceElement.style.setProperty('--roll-z-start', `${Math.random() * 120}deg`);
        this.diceElement.classList.remove('is-settled');
        this.sceneElement.classList.remove('is-settled');
        this.sceneElement.classList.add('is-rolling');
        this.diceElement.classList.add('is-rolling');
    }
    stopDice(value) {
        const currentTransform = getComputedStyle(this.cubeElement).transform;
        this.diceElement.classList.remove('is-rolling');
        this.sceneElement.classList.remove('is-rolling');
        this.setFace(value);
        const finalTransform = getComputedStyle(this.diceElement).getPropertyValue('--dice-final-transform').trim();
        this.diceElement.classList.add('is-settled');
        this.sceneElement.classList.add('is-settled');
        this.cubeElement.style.animation = 'none';
        this.cubeElement.style.transform = currentTransform;
        this.shadowElement.style.animation = 'none';
        this.settleAnimation?.cancel();
        this.settleAnimation = this.cubeElement.animate([
            {
                transform: currentTransform === 'none' ? 'rotateX(-24deg) rotateY(38deg)' : currentTransform,
                offset: 0
            },
            {
                transform: `${finalTransform} translateY(-8px) scale3d(1.04, 1.04, 1.04)`,
                offset: 0.45
            },
            {
                transform: `${finalTransform} translateY(2px) scale3d(0.985, 0.985, 0.985)`,
                offset: 0.72
            },
            {
                transform: `${finalTransform} translateY(0) scale3d(1, 1, 1)`,
                offset: 1
            }
        ], {
            duration: 420,
            easing: 'cubic-bezier(0.18, 0.9, 0.22, 1)',
            fill: 'forwards'
        });
        this.shadowElement.animate([
            {
                opacity: 0.34,
                transform: 'translateX(-50%) rotateX(86deg) translateZ(-28px) scale(0.78)'
            },
            {
                opacity: 0.62,
                transform: 'translateX(-50%) rotateX(86deg) translateZ(-28px) scale(0.98)'
            },
            {
                opacity: 0.5,
                transform: 'translateX(-50%) rotateX(86deg) translateZ(-28px) scale(0.92)'
            }
        ], {
            duration: 420,
            easing: 'cubic-bezier(0.18, 0.9, 0.22, 1)',
            fill: 'none'
        });
        this.settleAnimation.onfinish = ()=>{
            this.cubeElement.style.animation = '';
            this.cubeElement.style.transform = finalTransform;
            this.diceElement.classList.remove('is-settled');
            this.sceneElement.classList.remove('is-settled');
        };
    }
}


var $b24bdfd3a6697b3f$exports = {};
$b24bdfd3a6697b3f$exports = import.meta.resolve("15Ghq");


var $635a0c92db9d0d5b$exports = {};
$635a0c92db9d0d5b$exports = import.meta.resolve("2X8Dx");


var $96b71dea88513ffe$exports = {};
$96b71dea88513ffe$exports = import.meta.resolve("3ZFaq");


var $abddd075b367bc0e$exports = {};
$abddd075b367bc0e$exports = import.meta.resolve("94Flh");


var $f168acc10fccd074$exports = {};
$f168acc10fccd074$exports = import.meta.resolve("4hhZW");


var $149ab2cd5fdd832c$exports = {};
$149ab2cd5fdd832c$exports = import.meta.resolve("jWJ0d");


var $04080527c8201b0c$exports = {};
$04080527c8201b0c$exports = import.meta.resolve("3D11P");


var $a426aa793ded5c75$exports = {};
$a426aa793ded5c75$exports = import.meta.resolve("1XgAk");


var $2909357a4b973cd1$exports = {};
$2909357a4b973cd1$exports = import.meta.resolve("8L2qt");


var $fb00564495ca5b64$exports = {};
$fb00564495ca5b64$exports = import.meta.resolve("27rOh");


var $a653b0422e3c92cb$exports = {};
$a653b0422e3c92cb$exports = import.meta.resolve("jAiBi");


var $912aa1570ebc53b4$exports = {};
$912aa1570ebc53b4$exports = import.meta.resolve("koibZ");


var $72dc0ab1b00fba33$exports = {};
$72dc0ab1b00fba33$exports = import.meta.resolve("970Gd");


var $d14d9a6149135ea9$exports = {};
$d14d9a6149135ea9$exports = import.meta.resolve("4baUw");


var $37a19a8111678f78$exports = {};
$37a19a8111678f78$exports = import.meta.resolve("ezwki");


var $59e2fdb15f59e5bb$exports = {};
$59e2fdb15f59e5bb$exports = import.meta.resolve("jbxRU");


var $89ec045e336ad716$exports = {};
$89ec045e336ad716$exports = import.meta.resolve("57hBT");


var $00e9c2e55e5d5788$exports = {};
$00e9c2e55e5d5788$exports = import.meta.resolve("1LkTv");


class $cbb58ac183868e7d$export$cc74486daaaef499 {
    constructor(){
        this._titleElement = document.getElementById("event-page-title");
        this._descriptionElement = document.getElementById("event-page-description");
        this._photographyBorder = document.querySelector(".photography-border");
        this._eventPageChoicesBtnListElement = document.getElementById("event-page-choices-btn-list");
        this._imageElement = document.getElementById("event-page-image");
        this._developOverlay = document.getElementById("photo-develop-overlay");
        this._characterCard = document.getElementById("event-character-card");
        // Cada chave é um lugar do mapa — foto real de um ambiente abandonado
        // (Pripyat / Zona de Exclusão de Chernobyl), em preto e branco e 4:3.
        // Baixadas do Wikimedia Commons; créditos e licenças em
        // img/places/ATTRIBUTIONS.md. Ver scripts/fetch-place-images.mjs.
        this._images = new Map([
            [
                'placeHospital',
                new URL($b24bdfd3a6697b3f$exports).toString()
            ],
            [
                'placeApartmentBlock',
                new URL($635a0c92db9d0d5b$exports).toString()
            ],
            [
                'placeMaternity',
                new URL($96b71dea88513ffe$exports).toString()
            ],
            [
                'placePostOffice',
                new URL($abddd075b367bc0e$exports).toString()
            ],
            [
                'placeSchool',
                new URL($f168acc10fccd074$exports).toString()
            ],
            [
                'placePool',
                new URL($149ab2cd5fdd832c$exports).toString()
            ],
            [
                'placeApartmentInterior',
                new URL($04080527c8201b0c$exports).toString()
            ],
            [
                'placePharmacy',
                new URL($a426aa793ded5c75$exports).toString()
            ],
            [
                'placeKindergarten',
                new URL($2909357a4b973cd1$exports).toString()
            ],
            [
                'placeMural',
                new URL($fb00564495ca5b64$exports).toString()
            ],
            [
                'placeRiverPark',
                new URL($a653b0422e3c92cb$exports).toString()
            ],
            [
                'placeCentralSquare',
                new URL($912aa1570ebc53b4$exports).toString()
            ],
            [
                'placeRailwayBridge',
                new URL($72dc0ab1b00fba33$exports).toString()
            ],
            [
                'placeFerrisWheel',
                new URL($d14d9a6149135ea9$exports).toString()
            ],
            [
                'placeTrench',
                new URL($37a19a8111678f78$exports).toString()
            ],
            [
                'placeAbandonedCar',
                new URL($59e2fdb15f59e5bb$exports).toString()
            ],
            [
                'placePalaceCulture',
                new URL($89ec045e336ad716$exports).toString()
            ],
            [
                'placeFrozenRiver',
                new URL($00e9c2e55e5d5788$exports).toString()
            ]
        ]);
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._imageLoadRequestId = 0;
        this._pendingEvent = null;
    }
    start() {
        this._eventPageChoicesBtnListElement.innerHTML = '';
        if (this._pendingEvent) {
            this._currentEvent = this._pendingEvent;
            this._pendingEvent = null;
        }
        if (!this._currentEvent) {
            // Sem evento na fila — nada a mostrar aqui.
            this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
            return;
        }
        this.showEvent();
    }
    queueEvent(event) {
        this._pendingEvent = event;
    }
    get hasPendingEvent() {
        return this._pendingEvent != null;
    }
    showCharacterCard() {
        const character = this._currentEvent.character;
        if (!character) {
            this._characterCard.innerHTML = '';
            this._characterCard.style.display = 'none';
            return;
        }
        const sanityPct = character.sanity;
        const sanityClass = sanityPct > 50 ? 'sanity-ok' : sanityPct > 25 ? 'sanity-warn' : 'sanity-critical';
        this._characterCard.style.display = 'flex';
        const afflictions = character.showAfflictions();
        this._characterCard.innerHTML = `
            <img src="${character.imageURL}" alt="${character.name}" class="event-character-img">
            <div class="event-character-info">
                <div class="event-character-name">${character.name} <span class="event-character-kinship">${character.kinship}</span></div>
                ${afflictions ? `<div class="event-character-afflictions">${afflictions}</div>` : ''}
                <div class="character-sanity-bar">
                    <div class="character-sanity-fill ${sanityClass}" style="width:${sanityPct}%"></div>
                </div>
            </div>
        `;
    }
    showChoices() {
        this._eventPageChoicesBtnListElement.innerHTML = '';
        let diceManager = new (0, $850a1102bbecb448$export$bc2350a2190206a5)("dice-canvas");
        if (this.currentEvent.firstChoice) this.showChoice(this.currentEvent.firstChoice, diceManager);
        if (this.currentEvent.secondChoice) this.showChoice(this.currentEvent.secondChoice, diceManager);
    }
    showChoice(choice, diceManager) {
        const button = document.createElement("button");
        if (choice.skillCheck && choice.skillCheckFields) {
            choice.skillCheckFields.difficult = diceManager.getDifficult(choice.skillCheckFields.difficulty);
            let buttonText = choice.buttonText + " \xb7 " + diceManager.probabilityForTarget(choice.skillCheckFields.difficult.value);
            button.appendChild(document.createTextNode(buttonText));
            button.classList.add(choice.skillCheckFields.difficult.class);
        } else button.appendChild(document.createTextNode(choice.buttonText));
        button.addEventListener('click', ()=>this.selectChoice(choice));
        this._eventPageChoicesBtnListElement.appendChild(button);
    }
    selectChoice(choice) {
        this._game.audioManager.playButtonSound();
        this.currentChoice = choice;
        if (this.currentChoice.skillCheck) {
            this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).SKILLCHECK);
            return;
        }
        if (this.currentChoice.opensItemPicker) {
            this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).ITEM_PICKER);
            return;
        }
        if (this.currentChoice.normalResultPath) this.currentChoice.normalResultPath();
        this._game.stateManager.goToState(this.resolveNextState());
    }
    /**
     * Decide para onde ir depois que um evento se resolve:
     * epílogo (fronteira cruzada), enterro (alguém morreu) ou diário.
     */ resolveNextState() {
        if (this._game.state.pendingExplorationVictory) return (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).GAME_OVER;
        if (this._game.characterManager.getFirstCharacterDeadAndNotBuried()) return (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).RIP;
        return (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG;
    }
    get currentEvent() {
        return this._currentEvent;
    }
    getImagePath(imageName) {
        const imagePath = this._images.get(imageName);
        if (!imagePath) {
            console.error(`Image ${imageName} not found.`);
            return '';
        }
        return imagePath;
    }
    showEvent() {
        this._game.audioManager.playEventRevealSound();
        this._titleElement.style.display = 'block';
        this._titleElement.innerHTML = this._currentEvent.title;
        this._descriptionElement.innerHTML = this._currentEvent.description;
        this.renderEventImage();
        this.showCharacterCard();
        this.showChoices();
    }
    renderEventImage() {
        const imageName = this._currentEvent.image;
        if (imageName == '') {
            this._photographyBorder.style.display = 'none';
            this._imageElement.style.display = 'none';
            this._developOverlay.classList.remove('developing');
            this._developOverlay.style.background = 'transparent';
            return;
        }
        const path = this.getImagePath(imageName);
        if (!path) {
            this._photographyBorder.style.display = 'none';
            this._imageElement.style.display = 'none';
            this._developOverlay.classList.remove('developing');
            this._developOverlay.style.background = 'transparent';
            return;
        }
        const requestId = ++this._imageLoadRequestId;
        this._photographyBorder.style.display = 'block';
        this._imageElement.style.display = 'none';
        this._developOverlay.classList.remove('developing');
        this._developOverlay.style.background = '#000';
        const preloadImage = new Image();
        preloadImage.onload = ()=>{
            if (requestId !== this._imageLoadRequestId) return;
            this._game.audioManager.playImageRevealSound();
            this._imageElement.src = path;
            this._imageElement.style.display = 'block';
            this._developOverlay.classList.remove('developing');
            this._developOverlay.offsetWidth;
            this._developOverlay.classList.add('developing');
        };
        preloadImage.onerror = ()=>{
            if (requestId !== this._imageLoadRequestId) return;
            this._photographyBorder.style.display = 'none';
            this._imageElement.style.display = 'none';
            this._developOverlay.classList.remove('developing');
            this._developOverlay.style.background = 'transparent';
            console.error(`Failed to load image: ${path}`);
        };
        preloadImage.src = path;
    }
}



class $887e7e81328f4c8b$export$9735c82c4bae3302 {
    constructor(currentHour, anteMediem){
        this._currentHour = currentHour;
        this._anteMeridiem = anteMediem;
    }
    get currentHour() {
        return this._currentHour;
    }
    get anteMeridiem() {
        return this._anteMeridiem;
    }
    nextHour() {
        if (this._currentHour == 11) this._anteMeridiem = !this._anteMeridiem;
        if (this._currentHour == 12) this._currentHour = 1;
        else this._currentHour++;
    }
    showTime() {
        return (this._currentHour <= 9 ? '0' : '') + this._currentHour.toString() + ':00 ' + (this._anteMeridiem ? 'a.m' : 'p.m');
    }
}


const $44323cf7f5ca3923$export$b448c80d3380bcf5 = 2022;
class $44323cf7f5ca3923$export$eb5ccdbd077479c {
    constructor(){
        this._currentDay = 1;
        this._currentMapNodeId = 'camp';
        this._exploredLocationIds = new Set();
        this._traversedMapNodeIds = new Set([
            'camp'
        ]);
        this._traversedMapEdgeIds = new Set();
        this._gameOverMessage = '';
        this._pendingExplorationVictory = false;
        this._isVictoryEnding = false;
        this._clock = new (0, $887e7e81328f4c8b$export$9735c82c4bae3302)(8, true);
    }
    get currentDay() {
        return this._currentDay;
    }
    get clock() {
        return this._clock;
    }
    get currentMapNodeId() {
        return this._currentMapNodeId;
    }
    get gameOverMessage() {
        return this._gameOverMessage;
    }
    get exploredLocationsCount() {
        return this._exploredLocationIds.size;
    }
    get pendingExplorationVictory() {
        return this._pendingExplorationVictory;
    }
    get isVictoryEnding() {
        return this._isVictoryEnding;
    }
    setCurrentMapNode(nodeId) {
        this._currentMapNodeId = nodeId;
        this._traversedMapNodeIds.add(nodeId);
    }
    hasExploredLocation(nodeId) {
        return this._exploredLocationIds.has(nodeId);
    }
    markLocationExplored(nodeId) {
        this._exploredLocationIds.add(nodeId);
    }
    hasTraversedMapNode(nodeId) {
        return this._traversedMapNodeIds.has(nodeId);
    }
    markTraversedMapEdge(fromNodeId, toNodeId) {
        this._traversedMapEdgeIds.add(this.createMapEdgeId(fromNodeId, toNodeId));
    }
    hasTraversedMapEdge(fromNodeId, toNodeId) {
        return this._traversedMapEdgeIds.has(this.createMapEdgeId(fromNodeId, toNodeId));
    }
    setGameOverMessage(message, isVictory = false) {
        this._gameOverMessage = message;
        this._isVictoryEnding = isVictory;
    }
    setPendingExplorationVictory(value) {
        this._pendingExplorationVictory = value;
    }
    addDaysToCurrentDay(n) {
        this._currentDay += n;
    }
    passOneHour() {
        if (this._clock.currentHour == 12 && this._clock.anteMeridiem) this.addDaysToCurrentDay(1);
        this._clock.nextHour();
    }
    isDayLight() {
        if (this._clock.anteMeridiem) return this._clock.currentHour > 6 && this._clock.currentHour < 12;
        else return !(this._clock.currentHour > 6 && this._clock.currentHour < 12);
    }
    getRandomArbitrary(max) {
        return Math.floor(Math.random() * max);
    }
    createMapEdgeId(fromNodeId, toNodeId) {
        return `${fromNodeId}->${toNodeId}`;
    }
}


class $fc8f23560e9fa5ff$export$e6f377c5bf36ff9f {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._gameOverMessage = document.querySelector("#game-over-message");
        this._gameOverTitle = document.querySelector("#game-over-page h1");
        this._gameOverStats = document.getElementById("game-over-stats");
        this._tryAgainBtn = document.querySelector('#try-again-btn');
        this._tryAgainBtn.addEventListener('click', ()=>{
            this.onClickTryAgainBtn();
        });
    }
    start() {
        const isVictory = this._game.state.isVictoryEnding;
        this._gameOverTitle.textContent = isVictory ? 'Do Outro Lado.' : 'Fim.';
        this._gameOverTitle.style.color = isVictory ? 'var(--c-ok)' : 'var(--c-accent)';
        this._tryAgainBtn.textContent = 'De novo';
        this._gameOverMessage.innerHTML = isVictory ? this.buildVictoryEpilogue() : this.buildDefeatMessage();
        this._gameOverStats.textContent = this.buildStatsLine();
        if (isVictory) this._game.audioManager.playVictorySound();
        else this._game.audioManager.playGameOverSound();
    }
    buildVictoryEpilogue() {
        const crossing = this._game.state.gameOverMessage;
        const survivors = this._game.characterManager.getCharactersAlive();
        const dead = this._game.characterManager.getCharactersDead();
        const paragraphs = [
            crossing
        ];
        if (dead.length === 0) {
            paragraphs.push('Quatro partiram. Quatro chegaram.');
            paragraphs.push("\xabComo?\xbb \u2014 \xabJuntos.\xbb");
        } else if (survivors.length > 1) {
            paragraphs.push(`${this.formatNames(dead)} ficou. Um lugar vazio \xe0 mesa.`);
            paragraphs.push(this.buildMemorialLine(dead));
        } else {
            paragraphs.push("Um atravessou. Quatro mem\xf3rias.");
            paragraphs.push(this.buildMemorialLine(dead));
        }
        paragraphs.push(this.buildSanityCoda(survivors));
        return paragraphs.join('<br><br>');
    }
    /**
     * O estado em que se chega também é parte do final:
     * atravessar inteiro e atravessar em pedaços são histórias diferentes.
     */ buildSanityCoda(survivors) {
        if (survivors.length === 0) return '';
        const avg = survivors.reduce((s, c)=>s + c.sanity, 0) / survivors.length;
        if (avg >= 70) return '<em>Inteiros.</em>';
        if (avg >= 40) return '<em>Cansados. Vivos.</em>';
        return "<em>No que restou de voc\xeas.</em>";
    }
    buildDefeatMessage() {
        const message = this._game.state.gameOverMessage || 'A travessia termina aqui.';
        return `${message}<br><br>A cidade guarda os nomes.`;
    }
    buildMemorialLine(dead) {
        return dead.map((character)=>`\u{271D} ${character.name} \xb7 ${character.getDateOfBirth()}\u{2013}${0, $44323cf7f5ca3923$export$b448c80d3380bcf5}`).join("&nbsp;&nbsp;\xb7&nbsp;&nbsp;");
    }
    formatNames(characters) {
        const names = characters.map((character)=>character.name);
        if (names.length === 1) return names[0];
        return names.slice(0, -1).join(', ') + ' e ' + names[names.length - 1];
    }
    buildStatsLine() {
        const day = this._game.state.currentDay;
        const explored = this._game.state.exploredLocationsCount;
        const survivors = this._game.characterManager.getNumberOfCharactersAlive();
        if (this._game.state.isVictoryEnding) return `Dia ${day} \xb7 ${explored} lugares \xb7 ${survivors}/4`;
        const depth = this._game.mapManager.getCurrentDepth();
        const total = this._game.mapManager.totalSteps;
        return `Dia ${day} \xb7 ${explored} lugares \xb7 etapa ${depth}/${total}`;
    }
    onClickTryAgainBtn() {
        this._game.audioManager.playButtonSound();
        location.reload();
    }
}





const $dfe474540f60039a$var$RIP_QUOTES = {
    'Olena': 'Via demais.',
    'Mykola': 'Cresceu depressa demais.',
    'Sofiia': 'Guardava os nomes.'
};
class $dfe474540f60039a$export$63ed3fcf5e5b0cca {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._ripPageImageElement = document.querySelector("#rip-page-image");
        this._ripPageNameElement = document.querySelector("#rip-page-name");
        this._ripPageDatesElement = document.querySelector("#rip-page-dates");
        this._ripPageQuoteElement = document.querySelector("#rip-page-quote");
        this._ripPageStatusElement = document.querySelector("#rip-page-status");
        this._travelBtn = document.querySelector('#rip-page-back-btn');
        this._travelBtn.addEventListener('click', ()=>{
            this.onClickTravel();
        });
    }
    start() {
        const character = this._game.characterManager.getFirstCharacterDeadAndNotBuried();
        if (!character) {
            this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
            return;
        }
        this._game.audioManager.playCharacterDeathSound();
        this.showCharacter(character);
        character.buried = true;
    }
    showCharacter(character) {
        this._ripPageImageElement.src = character.imageURL;
        this._ripPageNameElement.innerHTML = character.name;
        this._ripPageDatesElement.innerHTML = `\u{2B50} ${character.getDateOfBirth()} \u{2014} ${0, $44323cf7f5ca3923$export$b448c80d3380bcf5} \u{271D}`;
        this._ripPageQuoteElement.innerHTML = $dfe474540f60039a$var$RIP_QUOTES[character.name] ?? 'Descanse.';
        this._ripPageStatusElement.innerHTML = 'A mente cedeu.';
    }
    onClickTravel() {
        this._game.audioManager.playButtonSound();
        const character = this._game.characterManager.getFirstCharacterDeadAndNotBuried();
        if (character) {
            this._game.audioManager.playCharacterDeathSound();
            this.showCharacter(character);
            character.buried = true;
            return;
        }
        if (this._game.eventManager.hasPendingEvent) {
            this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).EVENT);
            return;
        }
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
    }
}




class $fa7535ab82d62b12$export$cb68cc2163cd3f1 {
    constructor(name, kinship, sanity = 100, dateOfBirth, isDead){
        this._sanity = 100;
        this._isDead = false;
        this._buried = false;
        this._name = name;
        this._kinship = kinship;
        this._sanity = sanity;
        this._dateOfBirth = dateOfBirth;
        this._isDead = isDead;
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
    }
    get name() {
        return this._name;
    }
    get isDead() {
        return this._isDead;
    }
    get sanity() {
        return this._sanity;
    }
    get kinship() {
        return this._game.loc.l(this._kinship);
    }
    get isPlayer() {
        return this._kinship === 'you';
    }
    get buried() {
        return this._buried;
    }
    set buried(buried) {
        this._buried = buried;
    }
    get imageURL() {
        return this._imageURL;
    }
    set imageURL(imageURL) {
        this._imageURL = imageURL;
    }
    walkOneHour() {
        if (this._status != null) this.looseSanity(this._status?.healthPerHour ?? 0);
        // Fadiga: a estrada cobra de todos, a cada etapa.
        this.looseSanity($fa7535ab82d62b12$export$cb68cc2163cd3f1.FATIGUE_PER_HOUR);
    }
    static{
        this.FATIGUE_PER_HOUR = 4;
    }
    hasAffliction() {
        return this._status != null;
    }
    setStatus(status) {
        this._status = status;
    }
    removeStatus() {
        this._status = null;
    }
    showAfflictions() {
        return this._status?.name ?? '';
    }
    getSanity() {
        return this._sanity + '%';
    }
    getDateOfBirth() {
        return this._dateOfBirth;
    }
    looseSanity(sanityToLoose) {
        if (sanityToLoose < 0 || sanityToLoose > 100) throw new Error('Invalid value for sanityToLoose');
        if (this._isDead || this._sanity <= 0) return;
        this._sanity -= sanityToLoose;
        if (this._sanity <= 0) {
            this._sanity = 0;
            this._isDead = true;
            if (this.isPlayer) {
                this._game.state.setGameOverMessage('A mente cede. O caminho se perde.');
                this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).GAME_OVER);
            } else this._game.characterManager.onCharacterDied(this);
        }
    }
    /**
     * Luto nunca mata — deixa marcas. Reduz a sanidade sem
     * disparar morte, com piso mínimo de 5.
     */ sufferGrief(amount) {
        if (this._isDead) return;
        this._sanity = Math.max(5, this._sanity - amount);
    }
    increaseSanity(sanityToIncrease) {
        if (this._isDead) return;
        this._sanity += sanityToIncrease;
        if (this._sanity > 100) this._sanity = 100;
    }
}





var $9c7a2a4f88c432f6$export$a0472aa3a356446c = /*#__PURE__*/ function(LogType) {
    LogType[LogType["Result"] = 0] = "Result";
    LogType[LogType["StatusChange"] = 1] = "StatusChange";
    return LogType;
}({});
class $9c7a2a4f88c432f6$export$49b118289be48034 {
    constructor(){
        this._tempResultLogs = [];
        this._logs = [];
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this.initializeElements();
        this.addEventListeners();
        this.getAtributesPageElements();
    }
    initializeElements() {
        this._logListResult = document.querySelector("#log-list-result");
        this._bagBtn = document.querySelector('#bag-btn');
        this._walkBtn = document.querySelector("#walk-btn");
        this._dayField = document.getElementById("log-day-field");
        this._journeyNum = document.getElementById("journey-num");
        this._journeyFill = document.getElementById("journey-fill");
        this._journeyMarker = document.getElementById("journey-marker");
        this._journeyUnit = document.getElementById("journey-unit");
        this._charactersList = [];
    }
    addEventListeners() {
        this._bagBtn.addEventListener('click', ()=>this.onClickBag());
        this._walkBtn.addEventListener('click', ()=>this.onClickWalkBtn());
    }
    start() {
        this.showLogs();
        this.updateBagButton();
        this.updateWalkButton();
        this.showDayAndTime();
        this.showCharacters();
        this.showJourneyProgress();
    }
    updateBagButton() {
        if (this._game.bagManager.isEmpty()) {
            this._bagBtn.innerHTML = this._game.loc.l('bag-is-empty');
            this._bagBtn.disabled = true;
        } else {
            this._bagBtn.innerHTML = `Bolsa (${this._game.bagManager.showQuantityOfItems()})`;
            this._bagBtn.disabled = false;
        }
    }
    updateWalkButton() {
        this._walkBtn.innerHTML = this._game.loc.l('walk-one-hour');
        this._walkBtn.disabled = false;
    }
    showDayAndTime() {
        this._dayField.textContent = `Dia ${this._game.state.currentDay} \xb7 ${this._game.state.clock.showTime()}`;
    }
    showLogs() {
        this._logListResult.innerHTML = '';
        this.showResultLogs();
    }
    showResultLogs() {
        let result_logs = '';
        let count = 0;
        const stop = setInterval(()=>{
            if (count < this._tempResultLogs.length) {
                this._game.audioManager.playWriteSound();
                result_logs += `<li>${this._tempResultLogs[count]}</li>`;
                this._logListResult.innerHTML = result_logs;
                count++;
            } else {
                clearInterval(stop);
                this._logs = this._tempResultLogs;
                this._tempResultLogs = [];
                this._game.characterManager.savePreviousCharacters();
            }
        }, 300);
    }
    clearLogs() {
        this._logListResult.innerHTML = '';
    }
    isThereAnyTemporaryLog() {
        return this._tempResultLogs.length > 0;
    }
    addTempLog(log, logType) {
        if (logType === 0) this._tempResultLogs.push(log);
    }
    onClickBag() {
        this._game.audioManager.playButtonSound();
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).BAG);
    }
    onClickWalkBtn() {
        this._game.audioManager.playButtonSound();
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).MAP);
    }
    travelToSelectedLocation() {
        this._game.audioManager.playWalkSound();
        this._game.state.passOneHour();
        this.addTempLog(`A estrada cobra. \u{2212}${(0, $fa7535ab82d62b12$export$cb68cc2163cd3f1).FATIGUE_PER_HOUR}`, 0);
        this.walkOneHour();
        if (this._game.stateManager.currentState === (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).GAME_OVER) // A caminhada custou a mente do jogador.
        return;
        if (this._game.characterManager.getFirstCharacterDeadAndNotBuried()) {
            this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).RIP);
            return;
        }
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).EVENT);
    }
    walkOneHour() {
        this._game.characterManager.getCharactersAlive().forEach((character)=>{
            character.walkOneHour();
        });
    }
    showJourneyProgress() {
        const depth = this._game.mapManager.getCurrentDepth();
        const total = this._game.mapManager.totalSteps;
        const pct = total > 0 ? depth / total * 100 : 0;
        this._journeyNum.textContent = `Etapa ${depth}/${total}`;
        this._journeyNum.className = 'journey-num';
        this._journeyUnit.textContent = this.getActName(depth);
        this._journeyFill.style.width = pct + '%';
        this._journeyMarker.style.left = pct + '%';
        this._journeyMarker.className = 'journey-marker';
    }
    getActName(depth) {
        if (depth <= 2) return 'Ato I. A Cidade Morta.';
        if (depth <= 5) return 'Ato II. A Descida.';
        if (depth <= 7) return "Ato III. A \xdaltima Milha.";
        return 'Fronteira.';
    }
    getAtributesPageElements() {
        const characterIds = [
            'first',
            'second',
            'third',
            'fourth'
        ];
        characterIds.forEach((id, index)=>{
            this._charactersList[index] = {
                nameField: document.querySelector(`#${id}-character-name-field`),
                atributesField: document.querySelector(`#${id}-character-atributes-field`),
                afflictionsField: document.querySelector(`#${id}-character-afflictions-field`),
                sanityFill: document.getElementById(`${id}-character-sanity-fill`)
            };
        });
    }
    showCharacters() {
        const characters = [
            this._game.characterManager.characterDmytro,
            this._game.characterManager.characterOlena,
            this._game.characterManager.characterMykola,
            this._game.characterManager.characterSofiia
        ];
        characters.forEach((character, index)=>{
            this.showCharacter(character, index);
        });
    }
    showCharacter(character, index) {
        const { nameField: nameField, atributesField: atributesField, afflictionsField: afflictionsField, sanityFill: sanityFill } = this._charactersList[index];
        if (character.isDead) {
            nameField.innerHTML = `${character.name} - ${character.kinship} \u{1F480}`;
            atributesField.innerHTML = `${character.getDateOfBirth()} \u{2014} ${0, $44323cf7f5ca3923$export$b448c80d3380bcf5}`;
            afflictionsField.innerHTML = '';
            if (sanityFill) {
                sanityFill.style.width = '0%';
                sanityFill.className = 'character-sanity-fill';
            }
        } else {
            nameField.innerHTML = `${character.name} - ${character.kinship}`;
            nameField.className = 'character-name-field' + (character.sanity <= 25 ? ' critical' : '');
            atributesField.innerHTML = character.getSanity();
            afflictionsField.innerHTML = character.showAfflictions();
            if (sanityFill) {
                sanityFill.style.width = character.sanity + '%';
                sanityFill.className = 'character-sanity-fill ' + (character.sanity > 50 ? 'sanity-ok' : character.sanity > 25 ? 'sanity-warn' : 'sanity-critical');
            }
        }
    }
}





class $514d467852c05e06$export$36eb8cca929288cd {
    constructor(){
        this._items = [];
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._itemListElement = document.querySelector('#bag-item-list');
        this._selectedItemElement = document.getElementById('bag-selected-item');
        this._selectedItemDescriptionElement = document.getElementById('bag-selected-item-description');
        this._bagCloseBtn = document.querySelector('#bag-close-btn');
        this._bagThrowAwayBtn = document.getElementById('bag-throw-away-btn');
        this._bagCloseBtn.addEventListener('click', ()=>{
            this.onClickBagClose();
        });
        this._bagThrowAwayBtn.addEventListener('click', ()=>{
            this.onClickThrowAway();
        });
    }
    start() {
        this.hideSelectedItem();
        this.showItems();
        this._bagThrowAwayBtn.style.display = 'none';
    }
    onClickBagClose() {
        this._game.audioManager.playButtonSound();
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
    }
    onClickThrowAway() {
        this._game.audioManager.playThrowSound();
        this.removeOrDecreaseItem();
        this._itemListElement.innerHTML = '';
        this._selectedItemElement.style.display = 'none';
        this._selectedItemDescriptionElement.style.display = 'none';
        this.showItems();
        this._bagThrowAwayBtn.style.display = 'none';
    }
    hideSelectedItem() {
        this._selectedItemElement.innerHTML = '';
        this._selectedItemElement.style.display = 'none';
        this._selectedItemDescriptionElement.style.display = 'none';
    }
    showSelectedItem() {
        this._selectedItemElement.style.display = 'block';
        this._selectedItemDescriptionElement.style.display = 'block';
    }
    showItems() {
        this._itemListElement.innerHTML = '';
        if (this._items.length == 0) {
            this._itemListElement.innerHTML = 'Vazia.';
            return;
        }
        for (let item of this._items){
            const li = document.createElement("li");
            const button = document.createElement("button");
            button.appendChild(document.createTextNode(item.name + " \u2192 " + item.status.name + item.showAmount()));
            button.addEventListener('click', ()=>this.selectItem(item));
            li.appendChild(button);
            this._itemListElement.appendChild(li);
        }
    }
    putItem(itemToPut) {
        let existingItemIndex = this._items.findIndex((item)=>item.name == itemToPut.name);
        if (existingItemIndex >= 0) for(let i = 0; i < Math.max(1, itemToPut.amount); i++)this._items[existingItemIndex].increaseAmount();
        else this._items.push(itemToPut);
    }
    showCharacters() {
        for (const character of this._game.characters){
            const li = document.createElement("li");
            const button = document.createElement("button");
            if (character.isDead) {
                button.disabled = true;
                button.textContent = `${character.name} \u{271D}`;
            } else if (character.showAfflictions() !== this._selectedItem.status.name) {
                button.disabled = true;
                const affliction = character.showAfflictions();
                button.textContent = affliction ? `${character.name} \u{2014} ${affliction}` : character.name;
            } else {
                button.textContent = `${character.name} \u{2014} ${character.showAfflictions()}`;
                button.addEventListener('click', ()=>this.useItem(character));
            }
            li.appendChild(button);
            this._itemListElement.appendChild(li);
        }
    }
    selectItem(selectedItem) {
        this._game.audioManager.playButtonSound();
        this._selectedItem = selectedItem;
        this._itemListElement.innerHTML = '';
        this._selectedItemElement.innerHTML = `${this._selectedItem.name}`;
        this._selectedItemDescriptionElement.innerHTML = `\u{2192} ${this._selectedItem.status.name}. Quem?`;
        this.showSelectedItem();
        this.showCharacters();
        this._bagThrowAwayBtn.style.display = 'block';
    }
    useItem(character) {
        this._game.audioManager.playTakeItemSound();
        const affliction = character.showAfflictions();
        this.removeOrDecreaseItem();
        this.hideSelectedItem();
        this.showItems();
        character.removeStatus();
        this._game.log.addTempLog(`${this._selectedItem.name}. ${character.name}: ${affliction} some.`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
        this._bagThrowAwayBtn.style.display = 'none';
    }
    removeOrDecreaseItem() {
        if (this._selectedItem.amount > 1) this._selectedItem.decreaseAmount();
        else this.removeItem(this._selectedItem.name);
    }
    removeItem(itemName) {
        this._items = this._items.filter((item)=>item.name !== itemName);
    }
    checksIfAnItemExists(itemName) {
        let existingItemIndex = this._items.findIndex((item)=>item.name == itemName);
        return existingItemIndex != -1 ? true : false;
    }
    isEmpty() {
        return this._items.length <= 0;
    }
    showQuantityOfItems() {
        let itemCount = 0;
        for(let i = 0; i < this._items.length; i++)itemCount += this._items[i].amount == 0 ? 1 : this._items[i].amount;
        return itemCount;
    }
}




class $4b7b87bfcd759858$export$4d5c8163a511d38a {
    constructor(){
        this.currentState = (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).INTRO;
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
    }
    start() {}
    setState() {
        const { pages: pages } = this._game;
        pages.hideAll();
        switch(this.currentState){
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).INTRO:
                pages.show(pages.intro);
                this._game.introManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).EVENT:
                pages.show(pages.event);
                this._game.eventManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).SKILLCHECK:
                pages.show(pages.skillCheck);
                this._game.skillCheckManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG:
                pages.show(pages.log);
                this._game.logManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).GAME_OVER:
                pages.show(pages.gameOver);
                this._game.gameOverManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).RIP:
                pages.show(pages.rip);
                this._game.ripManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).BAG:
                pages.show(pages.bag);
                this._game.bagManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).ITEM_PICKER:
                pages.show(pages.itemPicker);
                this._game.itemPickerManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).MAP:
                pages.show(pages.map);
                this._game.mapManager.start();
        }
    }
    goToState(state) {
        if (this.currentState == (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).GAME_OVER) return;
        if (state !== (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).MAP && state !== (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG) this._game.audioManager.stopWalkSound();
        this.currentState = state;
        this.setState();
    }
}





class $0a8e38866719ea09$export$96e9906d6d93a972 {
    constructor(name, healthPerHour, effect){
        this.name = name;
        this.healthPerHour = healthPerHour;
        this.effect = effect;
    }
}
var $0a8e38866719ea09$export$1e6e956a5bf5b9ce = /*#__PURE__*/ function(StatusEffect) {
    StatusEffect["POSITIVE"] = "Positive";
    StatusEffect["NEGATIVE"] = "Negative";
    return StatusEffect;
}({});


class $831adfd47f352819$export$1d855623f2a478b9 {
    static{
        this.items = [
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)('Ansiedade', 4, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)('Culpa', 4, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)('Medo', 4, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("Depress\xe3o", 5, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)('Isolamento', 5, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)('Paranoia', 5, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("Alucina\xe7\xf5es", 6, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("P\xe2nico", 6, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)('Desespero', 7, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)('Trauma', 8, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE)
        ];
    }
    static getStatusByName(name) {
        return $831adfd47f352819$export$1d855623f2a478b9.items.find((affliction)=>affliction.name == name);
    }
}



class $ea43a44514016353$export$5f400b495260ae4b {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this.createAllCharacters();
        this.savePreviousCharacters();
        this.characters = [
            this.characterDmytro,
            this.characterOlena,
            this.characterMykola,
            this.characterSofiia
        ];
        this.previousCharacters = [
            this.previousCharacterDmytro,
            this.previousCharacterOlena,
            this.previousCharacterMykola,
            this.previousCharacterSofiia
        ];
    }
    start() {
        for(let i = 0; i < this.characters.length; i++){
            const imgElement = document.getElementById("rip-page-image-" + (i + 1));
            if (imgElement) this.characters[i].imageURL = imgElement.src;
        }
    }
    getCharactersDead() {
        return this.characters.filter((character)=>character.isDead);
    }
    createAllCharacters() {
        this.characterDmytro = new (0, $fa7535ab82d62b12$export$cb68cc2163cd3f1)('Dmytro', 'you', 100, '1985', false);
        this.characterOlena = new (0, $fa7535ab82d62b12$export$cb68cc2163cd3f1)('Olena', 'wife', 100, '1988', false);
        this.characterMykola = new (0, $fa7535ab82d62b12$export$cb68cc2163cd3f1)('Mykola', 'son', 100, '2003', false);
        this.characterSofiia = new (0, $fa7535ab82d62b12$export$cb68cc2163cd3f1)('Sofiia', 'daughter', 100, '2005', false);
    }
    savePreviousCharacters() {
        this.previousCharacterDmytro = this.cloneCharacter(this.characterDmytro);
        this.previousCharacterOlena = this.cloneCharacter(this.characterOlena);
        this.previousCharacterMykola = this.cloneCharacter(this.characterMykola);
        this.previousCharacterSofiia = this.cloneCharacter(this.characterSofiia);
    }
    cloneCharacter(character) {
        return new (0, $fa7535ab82d62b12$export$cb68cc2163cd3f1)(character.name, character.kinship, character.sanity, character.getDateOfBirth(), character.isDead);
    }
    getNumberOfCharactersAlive() {
        return this.characters.filter((character)=>!character.isDead).length;
    }
    getCharactersAlive() {
        return this.characters.filter((character)=>!character.isDead);
    }
    getFirstCharacterDeadAndNotBuried() {
        return this.characters.find((character)=>character.isDead && !character.buried);
    }
    picksACharacterAtRandom() {
        const characters = this.getCharactersAlive();
        const randomNumber = Math.floor(this._game.state.getRandomArbitrary(characters.length));
        return characters[randomNumber];
    }
    makeSomeoneInTheGroupGetStatus(characterName, status) {
        const character = this.getCharacterByName(characterName);
        character.setStatus((0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName(status));
        return character;
    }
    getCharacterByName(characterName) {
        return this.characters.find((character)=>character.name === characterName);
    }
    /**
     * Chamado quando um familiar (não o jogador) morre.
     * O luto atinge todos os sobreviventes — nunca mata, mas marca.
     */ onCharacterDied(dead) {
        this._game.log.addTempLog(`${dead.name} se foi.`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
        const survivors = this.getCharactersAlive();
        survivors.forEach((survivor)=>survivor.sufferGrief(25));
        if (survivors.length > 0) this._game.log.addTempLog("Luto. \u221225 nos vivos.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
    }
    /**
     * Evitar tem preço: −10 em quem se cala e −4 em quem assiste.
     * Uma família que só foge afunda inteira.
     */ applyAvoidCost(character) {
        character.looseSanity(10);
        this.getCharactersAlive().filter((other)=>other !== character).forEach((other)=>other.looseSanity(4));
    }
    /**
     * Falha em teste: dano base, agravado em 50% se o personagem
     * já rolou com a mente rachada (aflição ativa). Aplica a nova
     * aflição e devolve o dano real para o log.
     */ applyCheckFailure(character, baseDamage, afflictionName) {
        const aggravated = character.hasAffliction();
        const damage = Math.round(baseDamage * (aggravated ? 1.5 : 1));
        character.looseSanity(damage);
        if (!character.isDead) this.makeSomeoneInTheGroupGetStatus(character.name, afflictionName);
        if (aggravated) this._game.log.addTempLog("Mente rachada. A queda \xe9 pior.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
        return damage;
    }
}



var $47bc382d10598f77$exports = {};
$47bc382d10598f77$exports = JSON.parse("{\"walk-one-hour\":\"Continue\",\"your-family\":\"Yours\",\"you\":\"you\",\"wife\":\"wife\",\"son\":\"son\",\"daughter\":\"daughter\",\"bag-is-empty\":\"Bag\"}");


var $b958af03c4b8e2fb$exports = {};
$b958af03c4b8e2fb$exports = JSON.parse('{"walk-one-hour":"Seguir","your-family":"Os seus","you":"voc\xea","wife":"esposa","son":"filho","daughter":"filha","bag-is-empty":"Bolsa"}');


var $ae8a3c12e902894e$export$ce4fe1c9e6520c1a = /*#__PURE__*/ function(Language) {
    Language[Language["EnUs"] = 0] = "EnUs";
    Language[Language["PtBr"] = 1] = "PtBr";
    return Language;
}({});
class $ae8a3c12e902894e$export$30e2160809baa85b {
    constructor(language){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._currentLanguage = language;
    }
    l(key) {
        switch(this._currentLanguage){
            case 0:
                return $47bc382d10598f77$exports[key];
            case 1:
                return $b958af03c4b8e2fb$exports[key];
            default:
                return 'Localization Error';
        }
    }
}





class $efaa3735b04f10d5$export$21ea51713927a803 {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._startBtn = document.querySelector('#intro-start-btn');
        this._startBtn.addEventListener('click', ()=>this.onClickStart());
    }
    start() {}
    onClickStart() {
        this._game.audioManager.playButtonSound();
        this._game.log.addTempLog('Dia 1. Partimos.', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
        this._game.log.addTempLog('Oito etapas. Juntos.', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
    }
}




var $bc031f55e87bf7fc$export$3d7865934588d77e = /*#__PURE__*/ function(EventType) {
    EventType[EventType["Exploration"] = 0] = "Exploration";
    EventType[EventType["Combat"] = 1] = "Combat";
    EventType[EventType["Place"] = 2] = "Place";
    EventType[EventType["Psychological"] = 3] = "Psychological";
    return EventType;
}({});
class $bc031f55e87bf7fc$export$d61e24a684f9e51 {
    constructor(title, description, image, firstChoice, secondChoice, type, character, items){
        this._items = [];
        this._title = title;
        this._description = description;
        this._image = image;
        this.firstChoice = firstChoice;
        this.secondChoice = secondChoice;
        this._type = type;
        this._items = items ?? [];
        this._character = character;
    }
    get title() {
        return this._title;
    }
    get description() {
        return this._description;
    }
    get image() {
        return this._image;
    }
    get type() {
        return this._type;
    }
    get character() {
        return this._character;
    }
    get items() {
        return this._items;
    }
    willGiveItems() {
        return this._items ? this._items.length > 0 : false;
    }
}





class $cf06d41d2f58e0f1$export$6570b7397a911979 {
    static createDmytroEvents() {
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        let events = [];
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Escombros.', 'Quatro corpos. Quatro mochilas.', 'placeApartmentBlock', {
            buttonText: 'Olhar',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterDmytro.increaseSanity(15);
                        this._game.log.addTempLog("Dmytro: for\xe7a. +15", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterDmytro, 18, 'Ansiedade');
                        this._game.log.addTempLog(`Dmytro: Ansiedade. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: 'Desviar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterDmytro);
                this._game.log.addTempLog("Dmytro desvia. Os quatro seguem. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterDmytro));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Espelho.', 'Um rosto rachado. Quase o seu.', 'placePostOffice', {
            buttonText: 'Encarar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterDmytro);
                this._game.log.addTempLog("Dmytro encara. Nomes voltam. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, {
            buttonText: 'Desviar',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterDmytro.increaseSanity(15);
                        this._game.log.addTempLog("Dmytro vira o espelho. \xabDepois.\xbb +15", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterDmytro, 18, 'Culpa');
                        this._game.log.addTempLog(`Dmytro: Culpa. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterDmytro));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Gritos.', "Recreio. P\xe1tio vazio.", 'placeSchool', {
            buttonText: 'Entrar',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).CHALLENGING,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterDmytro.increaseSanity(20);
                        this._game.log.addTempLog('Dmytro fica. O eco morre. +20', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterDmytro, 32, 'Trauma');
                        this._game.log.addTempLog(`Dmytro: Trauma. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: 'Contornar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterDmytro);
                this._game.log.addTempLog("Os gritos seguem no vento. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterDmytro));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Casa.', 'Porta trancada. Botas pequenas.', 'placeApartmentInterior', {
            buttonText: 'Vasculhar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: null,
            opensItemPicker: true
        }, {
            buttonText: 'Seguir',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.log.addTempLog('A casa fica. Inteira.', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Place, this._game.characterManager.characterDmytro));
        return events;
    }
}






class $cc0da5454376274a$export$2be9c7801c485772 {
    static createMykolaEvents() {
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        let events = [];
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Choro.', "N\xe3o h\xe1 mais crian\xe7as aqui.", 'placeKindergarten', {
            buttonText: 'Procurar',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterMykola.increaseSanity(15);
                        this._game.log.addTempLog('Um brinquedo. Pilha fraca. +15', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterMykola, 18, "P\xe2nico");
                        this._game.log.addTempLog(`Mykola: P\xe2nico. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: 'Ignorar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterMykola);
                this._game.log.addTempLog("O choro segue junto. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterMykola));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Sasha.', "O balan\xe7o vazio range.", 'placeRiverPark', {
            buttonText: 'Despedir',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).CHALLENGING,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterMykola.increaseSanity(20);
                        this._game.log.addTempLog("\xabChega bem, Sasha.\xbb +20", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterMykola, 32, "Alucina\xe7\xf5es");
                        this._game.log.addTempLog(`Mykola: Alucina\xe7\xf5es. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: 'Fingir',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterMykola);
                this._game.log.addTempLog("Ningu\xe9m pergunta. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterMykola));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Passarela.', "Doze metros. T\xe1buas faltando.", 'placeRailwayBridge', {
            buttonText: 'Ir primeiro',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).CHALLENGING,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterMykola.increaseSanity(20);
                        this._game.log.addTempLog('O filho guia o pai. +20', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterMykola, 32, 'Ansiedade');
                        this._game.log.addTempLog(`Mykola: Ansiedade. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: 'No meio',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterMykola);
                this._game.log.addTempLog("Agarrado aos ombros. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterMykola));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Mochila.', 'Militar. Meio aberta.', 'placeTrench', {
            buttonText: 'Vasculhar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: null,
            opensItemPicker: true
        }, {
            buttonText: "N\xe3o tocar",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.log.addTempLog("Algumas hist\xf3rias ficam fechadas.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Place, this._game.characterManager.characterMykola));
        return events;
    }
}






class $c4173844005aa122$export$b1388e5e6738eebe {
    static createOlenaEvents() {
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        let events = [];
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Olhos.', 'O hospital observa.', 'placeHospital', {
            buttonText: 'Encarar',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterOlena.increaseSanity(15);
                        this._game.log.addTempLog('Olena encara. Nada. +15', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterOlena, 18, 'Paranoia');
                        this._game.log.addTempLog(`Olena: Paranoia. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: 'Apressar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterOlena);
                this._game.log.addTempLog("Os olhos viajam junto. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterOlena));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Sussurros.', "O ber\xe7\xe1rio canta baixinho.", 'placeMaternity', {
            buttonText: 'Ouvir',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterOlena.increaseSanity(15);
                        this._game.log.addTempLog('O primeiro choro de Sofiia. Aqui. +15', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterOlena, 18, 'Desespero');
                        this._game.log.addTempLog(`Olena: Desespero. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: 'Tapar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterOlena);
                this._game.log.addTempLog("Mem\xf3ria n\xe3o tem porta. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterOlena));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Sil\xeancio.", 'Denso. Com peso.', 'placePool', {
            buttonText: 'Gritar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterOlena);
                this._game.log.addTempLog("O eco volta sozinho. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, {
            buttonText: 'Atravessar',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterOlena.increaseSanity(15);
                        this._game.log.addTempLog('Um azulejo por vez. +15', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterOlena, 18, "Depress\xe3o");
                        this._game.log.addTempLog(`Olena: Depress\xe3o. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterOlena));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Farm\xe1cia.", "Saqueada. O fundo, n\xe3o.", 'placePharmacy', {
            buttonText: 'Vasculhar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: null,
            opensItemPicker: true
        }, {
            buttonText: 'Seguir',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.log.addTempLog('A porta fica encostada.', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Place, this._game.characterManager.characterOlena));
        return events;
    }
}






class $93631e155b1431be$export$442f8eaeaf400087 {
    static createSofiiaEvents() {
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        let events = [];
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Mural.', 'Rostos conhecidos. Nomes fugindo.', 'placeMural', {
            buttonText: 'Recitar',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterSofiia.increaseSanity(15);
                        this._game.log.addTempLog('Katya. Yulia. Vira. +15', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterSofiia, 18, 'Isolamento');
                        this._game.log.addTempLog(`Sofiia: Isolamento. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: 'Passar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterSofiia);
                this._game.log.addTempLog("De cabe\xe7a baixa. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterSofiia));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Sombras.', 'No fim da rua. Mais perto.', 'placeCentralSquare', {
            buttonText: 'Aproximar',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).CHALLENGING,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterSofiia.increaseSanity(20);
                        this._game.log.addTempLog('Casacos num varal. Riso. +20', (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterSofiia, 32, 'Medo');
                        this._game.log.addTempLog(`Sofiia: Medo. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: 'Desviar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterSofiia);
                this._game.log.addTempLog("Sem olhar para tr\xe1s. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterSofiia));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Roda.', 'Nunca girou. O ingresso, guardado.', 'placeFerrisWheel', {
            buttonText: 'Subir',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).CHALLENGING,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterSofiia.increaseSanity(20);
                        this._game.log.addTempLog("L\xe1 do alto: o caminho. \xabA gente chega.\xbb +20", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        const dmg = this._game.characterManager.applyCheckFailure(this._game.characterManager.characterSofiia, 32, 'Desespero');
                        this._game.log.addTempLog(`Sofiia: Desespero. \u{2212}${dmg}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: 'Soltar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.applyAvoidCost(this._game.characterManager.characterSofiia);
                this._game.log.addTempLog("Um enterro pequeno. De papel. \u221210 \xb7 grupo \u22124", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterSofiia));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Carro.', 'Quatro portas abertas. Pressa.', 'placeAbandonedCar', {
            buttonText: 'Vasculhar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: null,
            opensItemPicker: true
        }, {
            buttonText: 'Passar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.log.addTempLog("\xabQue tenham conseguido.\xbb", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Place, this._game.characterManager.characterSofiia));
        return events;
    }
}






class $cd88c76bf84b5d4c$export$a416da127df1a336 {
    static createStoryEvents() {
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        return [
            this.createPalaceRefugeEvent(),
            this.createBorderCrossingEvent()
        ];
    }
    static createPalaceRefugeEvent() {
        return new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Pal\xe1cio.", 'Paredes grossas. Um piano.', 'placePalaceCulture', {
            buttonText: 'Descansar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.getCharactersAlive().forEach((character)=>{
                    character.increaseSanity(15);
                });
                this._game.log.addTempLog("Tr\xeas m\xfasicas. Uma hora de paz. +15 para todos.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                this._game.log.addTempLog("Amanh\xe3: a fronteira.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, {
            buttonText: 'Vasculhar',
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: null,
            opensItemPicker: true
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Place, null);
    }
    static createBorderCrossingEvent() {
        return new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)('Fronteira.', 'O rio congelado. O outro lado.', 'placeFrozenRiver', {
            buttonText: 'Cruzar o gelo',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).CHALLENGING,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.getCharactersAlive().forEach((character)=>{
                            character.increaseSanity(10);
                        });
                        this._game.state.setGameOverMessage("O gelo range. Sustenta. Um por um \u2014 a margem norte.", true);
                        this._game.state.setPendingExplorationVictory(true);
                    },
                    failure: ()=>{
                        const dmytro = this._game.characterManager.characterDmytro;
                        const companions = this._game.characterManager.getCharactersAlive().filter((character)=>character !== dmytro);
                        dmytro.looseSanity(45);
                        if (companions.length > 0) {
                            const unlucky = companions[this._game.state.getRandomArbitrary(companions.length)];
                            unlucky.looseSanity(45);
                        }
                        if (!dmytro.isDead) {
                            this._game.state.setGameOverMessage("O gelo cede. M\xe3os na \xe1gua preta. A margem, enfim. Nem todos inteiros.", true);
                            this._game.state.setPendingExplorationVictory(true);
                        }
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: 'Esperar',
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.state.setGameOverMessage("A espera compensa. Na hora mais escura, a fam\xedlia cruza a cancela. Juntos.", true);
                        this._game.state.setPendingExplorationVictory(true);
                    },
                    failure: ()=>{
                        const dmytro = this._game.characterManager.characterDmytro;
                        const others = this._game.characterManager.getCharactersAlive().filter((character)=>character !== dmytro);
                        others.forEach((character)=>character.looseSanity(15));
                        dmytro.looseSanity(15);
                        if (!dmytro.isDead) {
                            this._game.state.setGameOverMessage("Holofotes. Correria no escuro. A cancela \u2014 atravessada. Por pouco.", true);
                            this._game.state.setPendingExplorationVictory(true);
                        }
                    }
                }
            },
            normalResultPath: null
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Exploration, this._game.characterManager.characterDmytro);
    }
}


class $bb1a6a7c453618b7$export$aded6179390a47eb {
    constructor(){
        this._events = [];
    }
    start() {
        this._events.push(...(0, $cf06d41d2f58e0f1$export$6570b7397a911979).createDmytroEvents());
        this._events.push(...(0, $cc0da5454376274a$export$2be9c7801c485772).createMykolaEvents());
        this._events.push(...(0, $c4173844005aa122$export$b1388e5e6738eebe).createOlenaEvents());
        this._events.push(...(0, $93631e155b1431be$export$442f8eaeaf400087).createSofiiaEvents());
        this._events.push(...(0, $cd88c76bf84b5d4c$export$a416da127df1a336).createStoryEvents());
    }
    get events() {
        return this._events;
    }
    getEventByTitle(title) {
        return this._events.find((event)=>event.title === title) ?? null;
    }
}


const $1b9b55c6f4e5d90c$var$MAP_NODES = [
    {
        id: 'camp',
        label: "Esta\xe7\xe3o",
        eventTitle: null,
        kind: 'camp',
        depth: 0,
        left: 50,
        top: 4,
        connections: [
            'a1',
            'a2'
        ]
    },
    {
        id: 'a1',
        label: 'Hospital 2',
        eventTitle: 'Olhos.',
        kind: 'event',
        depth: 1,
        left: 28,
        top: 13,
        connections: [
            'b1',
            'b2'
        ]
    },
    {
        id: 'a2',
        label: 'Bloco Kurchatov',
        eventTitle: 'Escombros.',
        kind: 'event',
        depth: 1,
        left: 72,
        top: 13,
        connections: [
            'b2',
            'b3'
        ]
    },
    {
        id: 'b1',
        label: 'Maternidade',
        eventTitle: 'Sussurros.',
        kind: 'event',
        depth: 2,
        left: 18,
        top: 23,
        connections: [
            'c1',
            'c2'
        ]
    },
    {
        id: 'b2',
        label: 'Correios',
        eventTitle: 'Espelho.',
        kind: 'event',
        depth: 2,
        left: 50,
        top: 23,
        connections: [
            'c1',
            'c2'
        ]
    },
    {
        id: 'b3',
        label: 'Escola 4',
        eventTitle: 'Gritos.',
        kind: 'event',
        depth: 2,
        left: 82,
        top: 23,
        connections: [
            'c1',
            'c2'
        ]
    },
    {
        id: 'c1',
        label: "Piscina Laz\xfarna",
        eventTitle: "Sil\xeancio.",
        kind: 'event',
        depth: 3,
        left: 28,
        top: 34,
        connections: [
            'd1',
            'd2',
            'd3'
        ]
    },
    {
        id: 'c2',
        label: 'Casa 17',
        eventTitle: 'Casa.',
        kind: 'event',
        depth: 3,
        left: 72,
        top: 34,
        connections: [
            'd2',
            'd3'
        ]
    },
    {
        id: 'd1',
        label: "Farm\xe1cia Velha",
        eventTitle: "Farm\xe1cia.",
        kind: 'event',
        depth: 4,
        left: 18,
        top: 45,
        connections: [
            'e1',
            'e2'
        ]
    },
    {
        id: 'd2',
        label: 'Creche Solnyshko',
        eventTitle: 'Choro.',
        kind: 'event',
        depth: 4,
        left: 50,
        top: 45,
        connections: [
            'e1',
            'e2'
        ]
    },
    {
        id: 'd3',
        label: 'Jardim Lastivka',
        eventTitle: 'Mural.',
        kind: 'event',
        depth: 4,
        left: 82,
        top: 45,
        connections: [
            'e1',
            'e2'
        ]
    },
    {
        id: 'e1',
        label: 'Parque do Rio',
        eventTitle: 'Sasha.',
        kind: 'event',
        depth: 5,
        left: 28,
        top: 58,
        connections: [
            'f1',
            'f2'
        ]
    },
    {
        id: 'e2',
        label: "Pra\xe7a da Cultura",
        eventTitle: 'Sombras.',
        kind: 'event',
        depth: 5,
        left: 72,
        top: 58,
        connections: [
            'f2',
            'f3'
        ]
    },
    {
        id: 'f1',
        label: "Passarela F\xe9rrea",
        eventTitle: 'Passarela.',
        kind: 'event',
        depth: 6,
        left: 18,
        top: 71,
        connections: [
            'g1',
            'g2'
        ]
    },
    {
        id: 'f2',
        label: 'Roda-Gigante',
        eventTitle: 'Roda.',
        kind: 'event',
        depth: 6,
        left: 50,
        top: 71,
        connections: [
            'g1',
            'g2'
        ]
    },
    {
        id: 'f3',
        label: 'Valeta Sul',
        eventTitle: 'Mochila.',
        kind: 'event',
        depth: 6,
        left: 82,
        top: 71,
        connections: [
            'g1',
            'g2'
        ]
    },
    {
        id: 'g1',
        label: 'Viaduto Leste',
        eventTitle: 'Carro.',
        kind: 'event',
        depth: 7,
        left: 28,
        top: 84,
        connections: [
            'border'
        ]
    },
    {
        id: 'g2',
        label: "Pal\xe1cio Energetik",
        eventTitle: "Pal\xe1cio.",
        kind: 'event',
        depth: 7,
        left: 72,
        top: 84,
        connections: [
            'border'
        ]
    },
    {
        id: 'border',
        label: 'Fronteira Norte',
        eventTitle: 'Fronteira.',
        kind: 'border',
        depth: 8,
        left: 50,
        top: 95,
        connections: []
    }
];
const $1b9b55c6f4e5d90c$export$16bd5d7035ca1195 = 8;
class $1b9b55c6f4e5d90c$export$c521bb0b406df9a3 {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._pageTitle = document.getElementById('map-page-title');
        this._pageContent = document.getElementById('map-page-content');
        this._pageActions = document.getElementById('map-page-actions');
        this._backButton = document.getElementById('map-back-btn');
        this._backButton.addEventListener('click', ()=>this.onBack());
    }
    get totalSteps() {
        return $1b9b55c6f4e5d90c$export$16bd5d7035ca1195;
    }
    getCurrentDepth() {
        const node = this.getNodeById(this._game.state.currentMapNodeId);
        return node ? node.depth : 0;
    }
    start() {
        this._game.audioManager.playMapOpenSound();
        this._pageTitle.textContent = 'Mapa.';
        this._pageContent.innerHTML = this.buildMapMarkup();
        this._pageActions.style.display = 'block';
        this.bindNodeEvents();
    }
    onBack() {
        this._game.audioManager.playButtonSound();
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
    }
    bindNodeEvents() {
        this._pageContent.querySelectorAll('[data-node-id]').forEach((button)=>{
            button.addEventListener('click', ()=>{
                const nodeId = button.dataset.nodeId;
                if (!nodeId) return;
                this.onSelectNode(nodeId);
            });
        });
    }
    onSelectNode(nodeId) {
        const selectedNode = this.getNodeById(nodeId);
        if (!selectedNode || !this.canMoveToNode(selectedNode)) return;
        this._game.audioManager.playButtonSound();
        this._game.state.markTraversedMapEdge(this._game.state.currentMapNodeId, selectedNode.id);
        this._game.state.setCurrentMapNode(selectedNode.id);
        if (selectedNode.kind === 'border') {
            const finale = this.getEventForNode(selectedNode);
            if (finale) this._game.eventManager.queueEvent(finale);
            this._game.logManager.travelToSelectedLocation();
            return;
        }
        if (this._game.state.hasExploredLocation(selectedNode.id)) {
            this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).MAP);
            return;
        }
        const event = this.getEventForNode(selectedNode);
        if (!event) return;
        this._game.state.markLocationExplored(selectedNode.id);
        this._game.eventManager.queueEvent(event);
        this._game.logManager.travelToSelectedLocation();
    }
    buildMapMarkup() {
        const currentNodeId = this._game.state.currentMapNodeId;
        const edges = this.buildEdgeSvgMarkup();
        const nodes = $1b9b55c6f4e5d90c$var$MAP_NODES.map((node)=>this.buildNodeMarkup(node, currentNodeId)).join('');
        return `
            <div class="map-sheet map-sheet--tree">
                <div class="map-graph map-graph--tree">
                    ${edges}
                    ${nodes}
                </div>
            </div>
        `;
    }
    buildNodeMarkup(node, currentNodeId) {
        const isCurrent = node.id === currentNodeId;
        const isVisited = node.kind === 'event' && this._game.state.hasExploredLocation(node.id);
        const isTraversed = this._game.state.hasTraversedMapNode(node.id);
        const canMove = this.canMoveToNode(node);
        const stateClass = isCurrent ? 'current' : node.kind === 'border' ? canMove ? 'border-available' : 'border-locked' : isTraversed ? 'traversed' : isVisited ? 'locked' : canMove ? 'available' : 'unreachable';
        const disabled = isCurrent || !canMove ? 'disabled' : '';
        return `
            <div class="map-node map-node--${node.kind} map-node--${stateClass}" style="left:${node.left}%; top:${node.top}%;">
                <button class="map-node-button" data-node-id="${node.id}" ${disabled} aria-label="${node.label}">
                    <span class="map-node-dot"></span>
                </button>
                <div class="map-node-label">${node.label}</div>
            </div>
        `;
    }
    buildEdgeSvgMarkup() {
        const rendered = new Set();
        const lines = [];
        $1b9b55c6f4e5d90c$var$MAP_NODES.forEach((node)=>{
            node.connections.forEach((targetId)=>{
                const key = [
                    node.id,
                    targetId
                ].sort().join(':');
                if (rendered.has(key)) return;
                const target = this.getNodeById(targetId);
                if (!target) return;
                rendered.add(key);
                const traveledClass = this._game.state.hasTraversedMapEdge(node.id, target.id) || this._game.state.hasTraversedMapEdge(target.id, node.id) ? ' map-edge-line--traversed' : '';
                lines.push(`<line class="map-edge-line${traveledClass}" x1="${node.left}" y1="${node.top}" x2="${target.left}" y2="${target.top}" />`);
            });
        });
        return `
            <svg class="map-edges" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
                ${lines.join('')}
            </svg>
        `;
    }
    canMoveToNode(node) {
        if (node.id === this._game.state.currentMapNodeId) return false;
        const currentNode = this.getNodeById(this._game.state.currentMapNodeId);
        if (!currentNode || !currentNode.connections.includes(node.id)) return false;
        return true;
    }
    getEventForNode(node) {
        if (!node.eventTitle) return null;
        const eventSeeds = new (0, $bb1a6a7c453618b7$export$aded6179390a47eb)();
        eventSeeds.start();
        return eventSeeds.getEventByTitle(node.eventTitle);
    }
    getNodeById(nodeId) {
        return $1b9b55c6f4e5d90c$var$MAP_NODES.find((node)=>node.id === nodeId);
    }
}


class $1274f8cb9d11f882$export$8be8c2ff45d443a3 {
    constructor(){}
    roll() {
        let min = Math.ceil(1);
        let max = Math.floor(6);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}





var $13f9998b7bf23c7a$export$d6c3ad4e8d47378f = /*#__PURE__*/ function(SkillCheckResults) {
    SkillCheckResults[SkillCheckResults["Success"] = 0] = "Success";
    SkillCheckResults[SkillCheckResults["Failure"] = 1] = "Failure";
    return SkillCheckResults;
}({});



class $9e93b9db2423d7df$export$ee498bc1e428f957 {
    constructor(){
        this._lastRollWasCritical = false;
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._resultLabel = document.querySelector('#skill-check-result-label');
        this._travelBtn = document.querySelector('#skill-check-back-btn');
        this._skillCheckExpected = document.querySelector('#skill-check-expected');
        this._flashElement = document.querySelector('#skill-check-flash');
        this._travelBtn.addEventListener('click', ()=>{
            this.onClickTravel();
        });
        this._diceManager = new (0, $850a1102bbecb448$export$bc2350a2190206a5)('dice-canvas');
    }
    renderExpectedFace(value) {
        this._skillCheckExpected.innerHTML = `
            <div class="expected-dice-wrap">
                <span class="expected-dice-label">M\xednimo.</span>
                <div class="expected-dice expected-dice--${value}">
                    ${this.buildExpectedPips(value)}
                </div>
            </div>
        `;
    }
    buildExpectedPips(value) {
        const pipMap = {
            1: [
                'center'
            ],
            2: [
                'top-left',
                'bottom-right'
            ],
            3: [
                'top-left',
                'center',
                'bottom-right'
            ],
            4: [
                'top-left',
                'top-right',
                'bottom-left',
                'bottom-right'
            ],
            5: [
                'top-left',
                'top-right',
                'center',
                'bottom-left',
                'bottom-right'
            ],
            6: [
                'top-left',
                'mid-left',
                'bottom-left',
                'top-right',
                'mid-right',
                'bottom-right'
            ]
        };
        return pipMap[value].map((position)=>`<span class="expected-pip expected-pip--${position}"></span>`).join('');
    }
    triggerFlash(type) {
        this._flashElement.classList.remove('flash-success', 'flash-failure');
        this._flashElement.offsetWidth;
        this._flashElement.classList.add(type === 'success' ? 'flash-success' : 'flash-failure');
    }
    start() {
        this._currentChoice = this._game.eventManager.currentChoice;
        const expectedValue = this._currentChoice.skillCheckFields.difficult.value;
        this.renderExpectedFace(expectedValue);
        this._diceManager.animateDice();
        this._travelBtn.disabled = true;
        this._resultLabel.style.visibility = 'hidden';
        setTimeout(()=>{
            this.startDiceRoll();
        }, 100);
    }
    startDiceRoll() {
        const dice = new (0, $1274f8cb9d11f882$export$8be8c2ff45d443a3)();
        // Agenda o resultado antes de tocar o som: áudio nunca pode travar o dado.
        setTimeout(()=>{
            this.stopShakeDice(dice);
        }, 500);
        this._game.audioManager.playDiceSound();
    }
    onClickTravel() {
        this._game.audioManager.playButtonSound();
        if (this._game.state.skillCheckResult == (0, $13f9998b7bf23c7a$export$d6c3ad4e8d47378f).Success) {
            this._currentChoice.skillCheckFields.resultPath.success();
            this.applyCriticalSuccessBonus();
        } else if (this._game.state.skillCheckResult == (0, $13f9998b7bf23c7a$export$d6c3ad4e8d47378f).Failure) {
            this._currentChoice.skillCheckFields.resultPath.failure();
            this.applyCriticalFailurePenalty();
        }
        if (this._game.stateManager.currentState === (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).GAME_OVER) // O resultado custou a mente do jogador — a tela de fim já assumiu.
        return;
        const nextState = this._game.eventManager.resolveNextState();
        if (nextState === (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG && this._game.state.skillCheckResult == (0, $13f9998b7bf23c7a$export$d6c3ad4e8d47378f).Success && this._currentChoice.skillCheckFields.canGiveItems) {
            this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).ITEM_PICKER);
            return;
        }
        this._game.stateManager.goToState(nextState);
    }
    applyCriticalSuccessBonus() {
        if (!this._lastRollWasCritical) return;
        const character = this._game.eventManager.currentEvent.character;
        if (!character || character.isDead) return;
        if (character.hasAffliction()) {
            const affliction = character.showAfflictions();
            character.removeStatus();
            this._game.log.addTempLog(`Cr\xedtico. ${character.name}: ${affliction} some.`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
        } else {
            character.increaseSanity(10);
            this._game.log.addTempLog(`Cr\xedtico. ${character.name}: +10`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
        }
    }
    applyCriticalFailurePenalty() {
        if (!this._lastRollWasCritical) return;
        const character = this._game.eventManager.currentEvent.character;
        if (!character || character.isDead) return;
        character.looseSanity(12);
        this._game.log.addTempLog(`Cr\xedtico. ${character.name}: \u{2212}12`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
    }
    stopShakeDice(dice) {
        this._resultLabel.style.visibility = 'visible';
        const diceValue = dice.roll();
        this._game.audioManager.playDiceSettleSound();
        this._diceManager.stopDice(diceValue);
        const expectedValue = this._currentChoice.skillCheckFields.difficult.value;
        this.renderExpectedFace(expectedValue);
        this._travelBtn.disabled = false;
        this._lastRollWasCritical = false;
        if (diceValue == 6) {
            this._game.audioManager.playSuccessSound();
            this.triggerFlash('success');
            this.setCriticalSuccess();
            this._lastRollWasCritical = true;
            this._game.state.skillCheckResult = (0, $13f9998b7bf23c7a$export$d6c3ad4e8d47378f).Success;
            return;
        }
        if (diceValue == 1) {
            this._game.audioManager.playFailSound();
            this.triggerFlash('failure');
            this.setCriticalFailure();
            this._lastRollWasCritical = true;
            this._game.state.skillCheckResult = (0, $13f9998b7bf23c7a$export$d6c3ad4e8d47378f).Failure;
            return;
        }
        if (diceValue >= expectedValue) {
            this._game.audioManager.playSuccessSound();
            this.triggerFlash('success');
            this.setSuccess();
            this._game.state.skillCheckResult = (0, $13f9998b7bf23c7a$export$d6c3ad4e8d47378f).Success;
            return;
        }
        this._game.audioManager.playFailSound();
        this.triggerFlash('failure');
        this.setFailure();
        this._game.state.skillCheckResult = (0, $13f9998b7bf23c7a$export$d6c3ad4e8d47378f).Failure;
    }
    setCriticalSuccess() {
        this._resultLabel.innerHTML = " SUCESSO CR\xcdTICO ";
        this._resultLabel.style.fontSize = '1.3em';
        this._resultLabel.classList.remove('red-color');
        this._resultLabel.classList.add('green-color');
    }
    setSuccess() {
        this._resultLabel.innerHTML = ' SUCESSO ';
        this._resultLabel.style.fontSize = '2.5em';
        this._resultLabel.classList.remove('red-color');
        this._resultLabel.classList.add('green-color');
    }
    setCriticalFailure() {
        this._resultLabel.innerHTML = " FALHA CR\xcdTICA ";
        this._resultLabel.style.fontSize = '1.3em';
        this._resultLabel.classList.add('red-color');
        this._resultLabel.classList.remove('green-color');
    }
    setFailure() {
        this._resultLabel.innerHTML = ' FALHA ';
        this._resultLabel.style.fontSize = '2.5em';
        this._resultLabel.classList.add('red-color');
        this._resultLabel.classList.remove('green-color');
    }
}



class $7562dc76fff808dc$export$6d08773d2e66f8f2 {
    constructor(name, status){
        this._name = name;
        this._amount = 0;
        this._status = status;
    }
    get name() {
        return this._name;
    }
    get amount() {
        return this._amount;
    }
    get status() {
        return this._status;
    }
    set amount(amount) {
        this._amount = amount;
    }
    showAmount() {
        return this._amount > 1 ? ' x ' + this._amount : '';
    }
    decreaseAmount() {
        this._amount--;
    }
    increaseAmount() {
        this._amount++;
    }
}




class $a586de1731fab2a5$export$188d8cb5ec09e5c7 {
    static{
        this._blueprints = [
            {
                name: 'Diazepam',
                cures: 'Ansiedade'
            },
            {
                name: 'Morfina',
                cures: 'Paranoia'
            },
            {
                name: "Cafe\xedna",
                cures: 'Desespero'
            },
            {
                name: "Di\xe1rio",
                cures: 'Culpa'
            },
            {
                name: 'Crucifixo',
                cures: 'Medo'
            },
            {
                name: 'Foto antiga',
                cures: "Alucina\xe7\xf5es"
            },
            {
                name: 'Carta',
                cures: 'Isolamento'
            },
            {
                name: 'Antidepressivos',
                cures: "Depress\xe3o"
            },
            {
                name: 'Curativos',
                cures: 'Trauma'
            },
            {
                name: 'Anfetamina',
                cures: "P\xe2nico"
            }
        ];
    }
    static getOneRandomItem() {
        const blueprint = this._blueprints[this.getRandomArbitrary(0, this._blueprints.length)];
        const item = new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)(blueprint.name, (0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName(blueprint.cures));
        item.amount = 1;
        return item;
    }
    static getRandomArbitrary(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }
}



class $4ac31c89200f3453$export$3dc9b393db657566 {
    constructor(){
        this._itemsToPick = [];
        this._myItems = [];
        this._myItemsMax = 2;
        this.itemsFound = 4;
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._continueBtn = document.querySelector('#item-picker-page-continue-btn');
        this._continueBtn.addEventListener('click', ()=>{
            this.onContinueBtn();
        });
        this._itemsToPickListElement = document.querySelector('#item-picker-page-items-to-pick');
        this._itemsFoundTitle = document.querySelector('#items-found-title');
        this._pageMessageElement = document.querySelector('#item-picker-page-message');
        this._myItemsListElement = document.querySelector('#item-picker-page-item-my-items');
        this._yourItemsTitle = document.querySelector('#your-items-title');
        this._takeAllBtn = document.querySelector('#item-picker-page-take-all-btn');
        this._takeAllBtn.addEventListener('click', ()=>{
            this.onTakeAllBtn();
        });
    }
    start() {
        this.character = this.resolveSearchingCharacter();
        this.showPageMessage();
        this._itemsToPick = [];
        this._myItems = [];
        for(let i = 0; i < this.itemsFound; i++){
            let itemFounded = (0, $a586de1731fab2a5$export$188d8cb5ec09e5c7).getOneRandomItem();
            this.addItemToPick(itemFounded);
        }
        this.showItems();
    }
    /**
     * Quem vasculha é o personagem do evento atual — é a história dele.
     * Se ele não estiver mais entre os vivos, outro assume.
     */ resolveSearchingCharacter() {
        const eventCharacter = this._game.eventManager.currentEvent?.character;
        if (eventCharacter && !eventCharacter.isDead) return eventCharacter;
        return this._game.characterManager.picksACharacterAtRandom();
    }
    showPageMessage() {
        this._itemsFoundTitle.style.display = 'none';
        this._continueBtn.style.display = 'none';
        this._itemsToPickListElement.style.display = 'none';
        this._myItemsListElement.style.display = 'none';
        this._yourItemsTitle.style.display = 'none';
        this._takeAllBtn.style.display = 'none';
        this._pageMessageElement.textContent = `${this.character.name} vasculha...`;
        this._pageMessageElement.style.display = 'block';
        setTimeout(()=>this.showPageElements(), 1500);
    }
    showPageElements() {
        this._game.audioManager.playItemFoundSound();
        this._itemsFoundTitle.style.display = 'block';
        this._continueBtn.style.display = 'block';
        this._itemsToPickListElement.style.display = 'block';
        this._myItemsListElement.style.display = 'block';
        this._yourItemsTitle.style.display = 'block';
        this._takeAllBtn.style.display = 'block';
        this._pageMessageElement.style.display = 'none';
    }
    showItems() {
        if (this._itemsToPick.length <= this._myItemsMax - this.countMyItems()) this._takeAllBtn.disabled = false;
        else this._takeAllBtn.disabled = true;
        this.showItemsToPick();
        this.showMyItems();
    }
    countMyItems() {
        return this._myItems.reduce((total, item)=>total + Math.max(1, item.amount), 0);
    }
    countItemsToPick() {
        return this._itemsToPick.reduce((total, item)=>total + Math.max(1, item.amount), 0);
    }
    showItemsToPick() {
        this._itemsToPickListElement.innerHTML = '';
        for (let item of this._itemsToPick){
            const li = document.createElement("li");
            const button = document.createElement("button");
            button.appendChild(document.createTextNode(item.name + " \u2192 " + item.status.name + item.showAmount()));
            button.addEventListener('click', ()=>this.selectItemToPick(item));
            if (this.countMyItems() >= this._myItemsMax) button.disabled = true;
            li.appendChild(button);
            this._itemsToPickListElement.appendChild(li);
        }
    }
    showMyItems() {
        this._yourItemsTitle.innerHTML = `Levar (${this.countMyItems()}/${this._myItemsMax})`;
        this._myItemsListElement.innerHTML = '';
        for (let item of this._myItems){
            const li = document.createElement("li");
            const button = document.createElement("button");
            button.appendChild(document.createTextNode(item.name + " \u2192 " + item.status.name + item.showAmount()));
            button.addEventListener('click', ()=>this.selectItemMyItem(item));
            li.appendChild(button);
            this._myItemsListElement.appendChild(li);
        }
    }
    selectItemToPick(selectedItem) {
        this._game.audioManager.playTakeItemSound();
        this.moveOneItem(selectedItem, this._itemsToPick, (item)=>this.addMyItem(item));
        this.showItems();
    }
    selectItemMyItem(selectedItem) {
        this._game.audioManager.playThrowSound();
        this.moveOneItem(selectedItem, this._myItems, (item)=>this.addItemToPick(item));
        this.showItems();
    }
    /**
     * Move uma unidade do item entre as listas, preservando pilhas.
     */ moveOneItem(selectedItem, fromList, addTo) {
        if (selectedItem.amount > 1) selectedItem.decreaseAmount();
        else {
            const index = fromList.indexOf(selectedItem);
            if (index >= 0) fromList.splice(index, 1);
        }
        const single = new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)(selectedItem.name, selectedItem.status);
        single.amount = 1;
        addTo(single);
    }
    addItemToPick(itemToPut) {
        let existingItemIndex = this._itemsToPick.findIndex((item)=>item.name == itemToPut.name);
        if (existingItemIndex >= 0) this._itemsToPick[existingItemIndex].increaseAmount();
        else this._itemsToPick.push(itemToPut);
    }
    addMyItem(itemToPut) {
        let existingItemIndex = this._myItems.findIndex((item)=>item.name == itemToPut.name);
        if (existingItemIndex >= 0) this._myItems[existingItemIndex].increaseAmount();
        else this._myItems.push(itemToPut);
    }
    onContinueBtn() {
        this._game.audioManager.playButtonSound();
        for(let i = 0; i < this._myItems.length; i++){
            this._game.bagManager.putItem(this._myItems[i]);
            this._game.log.addTempLog(`${this.character.name}: +${this._myItems[i].name}${this._myItems[i].showAmount()}`, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
        }
        this._game.stateManager.goToState(this._game.eventManager.resolveNextState());
    }
    onTakeAllBtn() {
        if (this.countItemsToPick() > this._myItemsMax - this.countMyItems()) return;
        this._game.audioManager.playTakeItemSound();
        const itemsToMove = [
            ...this._itemsToPick
        ];
        this._itemsToPick = [];
        itemsToMove.forEach((item)=>{
            let existingItemIndex = this._myItems.findIndex((myItem)=>myItem.name == item.name);
            if (existingItemIndex >= 0) for(let i = 0; i < Math.max(1, item.amount); i++)this._myItems[existingItemIndex].increaseAmount();
            else this._myItems.push(item);
        });
        this.showItems();
    }
}


class $147779db9aa8deb0$export$557a8016f4e0c1ba {
    // ─── Core ─────────────────────────────────────────────────────────────
    getCtx() {
        if (!this.ctx) {
            this.ctx = new AudioContext();
            this.masterGain = this.ctx.createGain();
            this.masterGain.gain.value = 0.70;
            this.masterGain.connect(this.ctx.destination);
        }
        if (this.ctx.state === 'suspended') this.ctx.resume();
        return this.ctx;
    }
    out() {
        this.getCtx();
        return this.masterGain;
    }
    makeNoise(seconds) {
        const ctx = this.getCtx();
        const n = Math.max(1, Math.floor(ctx.sampleRate * seconds));
        const buf = ctx.createBuffer(1, n, ctx.sampleRate);
        const d = buf.getChannelData(0);
        for(let i = 0; i < n; i++)d[i] = Math.random() * 2 - 1;
        return buf;
    }
    // Hard clip — simulates piezo buzzer / ceramic resonator distortion
    hardClip() {
        const ctx = this.getCtx();
        const ws = ctx.createWaveShaper();
        const n = 256;
        const curve = new Float32Array(n);
        for(let i = 0; i < n; i++){
            const x = i / (n - 1) * 2 - 1;
            curve[i] = Math.max(-0.65, Math.min(0.65, x * 3.5));
        }
        ws.curve = curve;
        return ws;
    }
    // ─── Primitives ───────────────────────────────────────────────────────
    // Soviet piezo buzzer: square wave → hard clip.
    // This is how BK-0010 / UKNC played sounds — CPU toggling a port bit.
    buzzer(freq, dur, vol, delay = 0) {
        if (this.noSound) return;
        try {
            const ctx = this.getCtx();
            const t = ctx.currentTime + delay;
            const o = ctx.createOscillator();
            o.type = 'square';
            o.frequency.value = freq;
            const ws = this.hardClip();
            const g = ctx.createGain();
            g.gain.setValueAtTime(vol, t);
            g.gain.setValueAtTime(0.0001, t + dur - 0.002);
            o.connect(ws);
            ws.connect(g);
            g.connect(this.out());
            o.start(t);
            o.stop(t + dur + 0.004);
        } catch  {
            this.noSound = true;
        }
    }
    // FSK burst: single oscillator with scheduled frequency flips between f1/f2.
    // Exactly how Soviet computers encoded data on cassette tape (МК-60, etc.)
    // and how the CPU sounded when doing intensive I/O.
    fsk(dur, delay = 0, vol = 0.062, f1 = 1200, f2 = 2400) {
        if (this.noSound) return;
        try {
            const ctx = this.getCtx();
            const t0 = ctx.currentTime + delay;
            const o = ctx.createOscillator();
            o.type = 'square';
            o.frequency.setValueAtTime(f1, t0);
            let t = 0.002;
            while(t < dur - 0.002){
                // Segment lengths: ~4–13 ms (encode 0s and 1s at tape speed)
                const seg = 0.004 + Math.random() * 0.009;
                o.frequency.setValueAtTime(Math.random() > 0.5 ? f1 : f2, t0 + t);
                t += seg;
            }
            const ws = this.hardClip();
            const g = ctx.createGain();
            g.gain.setValueAtTime(vol, t0);
            g.gain.setValueAtTime(0.0001, t0 + dur - 0.001);
            o.connect(ws);
            ws.connect(g);
            g.connect(this.out());
            o.start(t0);
            o.stop(t0 + dur + 0.003);
        } catch  {
            this.noSound = true;
        }
    }
    // Mechanical relay / keyboard click — physical impact sound
    relayClick(vol = 0.065, delay = 0) {
        if (this.noSound) return;
        try {
            const ctx = this.getCtx();
            const t = ctx.currentTime + delay;
            const dur = 0.016;
            const src = ctx.createBufferSource();
            src.buffer = this.makeNoise(dur);
            const lp = ctx.createBiquadFilter();
            lp.type = 'lowpass';
            lp.frequency.value = 4000;
            const g = ctx.createGain();
            g.gain.setValueAtTime(vol, t);
            g.gain.exponentialRampToValueAtTime(0.001, t + dur);
            src.connect(lp);
            lp.connect(g);
            g.connect(this.out());
            src.start(t);
        } catch  {
            this.noSound = true;
        }
    }
    // ─── Button ───────────────────────────────────────────────────────────
    // Heavy Soviet keyboard key: mechanical click + buzzer confirmation
    playButtonSound() {
        this.relayClick(0.07);
        this.buzzer(880, 0.032, 0.050, 0.010);
    }
    // ─── Dice rolling ─────────────────────────────────────────────────────
    // FSK burst — sounds like the computer reading random data from tape
    // while "rolling" the result. Distinctly Soviet-computer.
    playDiceSound() {
        this.fsk(0.480, 0, 0.068, 1200, 2400);
    }
    // ─── Dice settle ──────────────────────────────────────────────────────
    // Single short buzzer beep — result confirmed
    playDiceSettleSound() {
        this.buzzer(440, 0.075, 0.085);
    }
    // ─── Ding ─────────────────────────────────────────────────────────────
    // Three identical buzzer pulses — notification pattern
    playDingSound() {
        [
            0,
            0.090,
            0.180
        ].forEach((d)=>this.buzzer(660, 0.055, 0.060, d));
    }
    // ─── Fail ─────────────────────────────────────────────────────────────
    // Three slow descending buzzer tones — Soviet alarm pattern.
    // Not a melody — just three falling steps, functional.
    playFailSound() {
        this.buzzer(440, 0.160, 0.085, 0.000);
        this.buzzer(330, 0.160, 0.085, 0.200);
        this.buzzer(220, 0.240, 0.085, 0.400);
    }
    // ─── Success ──────────────────────────────────────────────────────────
    // Two ascending buzzer beeps — minimal positive confirmation
    playSuccessSound() {
        this.buzzer(440, 0.080, 0.075, 0.000);
        this.buzzer(880, 0.110, 0.075, 0.110);
    }
    // ─── Take item ────────────────────────────────────────────────────────
    // Single buzzer beep
    playTakeItemSound() {
        this.buzzer(660, 0.065, 0.065);
    }
    // ─── Throw ────────────────────────────────────────────────────────────
    // Relay click + low buzzer — discarding with physical feedback
    playThrowSound() {
        this.relayClick(0.07);
        this.buzzer(220, 0.080, 0.065, 0.012);
    }
    // ─── Walk ─────────────────────────────────────────────────────────────
    // Relay click per step — no musical tone, purely mechanical
    playWalkSound() {
        if (this.noSound || this.walkActive) return;
        this.walkActive = true;
        this.walkStepIndex = 0;
        this.scheduleStep();
    }
    stopWalkSound() {
        this.walkActive = false;
        if (this.walkTimeoutId !== null) {
            clearTimeout(this.walkTimeoutId);
            this.walkTimeoutId = null;
        }
    }
    scheduleStep() {
        if (!this.walkActive) return;
        this.relayClick(0.08);
        this.walkStepIndex++;
        const interval = this.walkStepIndex % 2 === 0 ? 670 : 750;
        this.walkTimeoutId = setTimeout(()=>this.scheduleStep(), interval);
    }
    // ─── Write ────────────────────────────────────────────────────────────
    // Mechanical keyboard key press — click only, no buzzer
    playWriteSound() {
        this.relayClick(0.048);
    }
    // ─── Event reveal ─────────────────────────────────────────────────────
    // 50 Hz hum (Soviet power grid frequency) slowly rising — like a
    // transformer or CRT powering up something you shouldn't have opened
    playEventRevealSound() {
        if (this.noSound) return;
        try {
            const ctx = this.getCtx();
            const now = ctx.currentTime;
            const o = ctx.createOscillator();
            o.type = 'triangle';
            o.frequency.value = 50;
            const g = ctx.createGain();
            g.gain.setValueAtTime(0, now);
            g.gain.linearRampToValueAtTime(0.042, now + 0.40);
            g.gain.exponentialRampToValueAtTime(0.001, now + 1.30);
            o.connect(g);
            g.connect(this.out());
            o.start(now);
            o.stop(now + 1.35);
        } catch  {
            this.noSound = true;
            return;
        }
        // Brief static burst at the start (relay switching / CRT discharge)
        this.relayClick(0.055);
    }
    // ─── Image reveal ─────────────────────────────────────────────────────
    // Short FSK burst — like data being loaded from tape into memory
    playImageRevealSound() {
        this.fsk(0.180, 0, 0.055, 600, 1200);
    }
    // ─── Sleep ────────────────────────────────────────────────────────────
    // Slow low buzzer pulses — "standby" indicator on Soviet terminal
    playSleepSound() {
        [
            0,
            0.70,
            1.40,
            2.10
        ].forEach((d)=>this.buzzer(120, 0.130, 0.038, d));
    }
    // ─── Wake ─────────────────────────────────────────────────────────────
    // Two short ascending buzzer beeps — wake signal
    playWakeSound() {
        this.buzzer(220, 0.045, 0.048, 0.000);
        this.buzzer(440, 0.060, 0.048, 0.055);
    }
    // ─── Character death ──────────────────────────────────────────────────
    // Single continuous tone descending over 3 seconds — like a flatline
    // on old Soviet medical equipment. No melody, no steps. One long fall.
    playCharacterDeathSound() {
        if (this.noSound) return;
        try {
            const ctx = this.getCtx();
            const now = ctx.currentTime;
            const dur = 3.2;
            const o = ctx.createOscillator();
            o.type = 'triangle';
            o.frequency.setValueAtTime(330, now);
            o.frequency.exponentialRampToValueAtTime(88, now + dur);
            const g = ctx.createGain();
            g.gain.setValueAtTime(0.075, now);
            g.gain.exponentialRampToValueAtTime(0.001, now + dur);
            o.connect(g);
            g.connect(this.out());
            o.start(now);
            o.stop(now + dur + 0.05);
        } catch  {
            this.noSound = true;
        }
    }
    // ─── Game over ────────────────────────────────────────────────────────
    // Three slow identical alarm buzzes — Soviet industrial alarm.
    // No descending melody — just three functional warning pulses.
    playGameOverSound() {
        [
            0,
            0.38,
            0.76
        ].forEach((d)=>this.buzzer(220, 0.280, 0.090, d));
    }
    // ─── Victory ──────────────────────────────────────────────────────────
    // Five short ascending buzzer steps — still Soviet-terse, just upward
    playVictorySound() {
        [
            220,
            330,
            440,
            550,
            660
        ].forEach((f, i)=>this.buzzer(f, 0.085, 0.072, i * 0.100));
    }
    // ─── Map open ─────────────────────────────────────────────────────────
    // Brief FSK burst — accessing stored map data from memory
    playMapOpenSound() {
        this.fsk(0.075, 0, 0.050, 800, 1600);
    }
    // ─── Item found ───────────────────────────────────────────────────────
    // Short FSK burst + two confirmation beeps
    playItemFoundSound() {
        this.fsk(0.120, 0, 0.058, 1200, 2400);
        this.buzzer(660, 0.055, 0.060, 0.130);
        this.buzzer(880, 0.070, 0.060, 0.195);
    }
    // ─── Rain / Geiger (no-ops) ───────────────────────────────────────────
    playRainSound() {}
    stopRainSound() {}
    startGeigerAmbient() {}
    stopGeigerAmbient() {}
    // ─── Legacy compat ────────────────────────────────────────────────────
    playSound(soundName, loop = false) {
        switch(soundName){
            case 'button':
                return this.playButtonSound();
            case 'dice':
                return this.playDiceSound();
            case 'ding':
                return this.playDingSound();
            case 'fail':
                return this.playFailSound();
            case 'success':
                return this.playSuccessSound();
            case 'takeItem':
                return this.playTakeItemSound();
            case 'throw':
                return this.playThrowSound();
            case 'walk':
                return loop ? this.playWalkSound() : undefined;
            case 'write':
                return this.playWriteSound();
        }
    }
    constructor(){
        this.ctx = null;
        this.masterGain = null;
        this.noSound = false;
        this.walkActive = false;
        this.walkStepIndex = 0;
        this.walkTimeoutId = null;
    }
}



class $1674f3ecc702ebaa$export$ddfe55de202c2217 {
    constructor(){
        this.intro = document.getElementById("intro-page");
        this.log = document.getElementById("log-page");
        this.event = document.getElementById("event-page");
        this.skillCheck = document.getElementById("skill-check-page");
        this.gameOver = document.getElementById("game-over-page");
        this.rip = document.getElementById("rip-page");
        this.bag = document.getElementById("bag-page");
        this.itemPicker = document.getElementById("item-picker-page");
        this.map = document.querySelector("#map-page");
    }
    show(page) {
        page.style.display = 'flex';
    }
    hide(page) {
        page.style.display = 'none';
    }
    hideAll() {
        [
            this.intro,
            this.log,
            this.event,
            this.skillCheck,
            this.gameOver,
            this.bag,
            this.rip,
            this.itemPicker,
            this.map
        ].forEach((p)=>this.hide(p));
    }
}


class $7b066675d1aa79fa$export$985739bfa5723e08 {
    constructor(){
        this.state = new (0, $44323cf7f5ca3923$export$eb5ccdbd077479c)();
        this.pages = new (0, $1674f3ecc702ebaa$export$ddfe55de202c2217)();
    }
    static getInstance() {
        if (!$7b066675d1aa79fa$export$985739bfa5723e08._instance) $7b066675d1aa79fa$export$985739bfa5723e08._instance = new $7b066675d1aa79fa$export$985739bfa5723e08();
        return $7b066675d1aa79fa$export$985739bfa5723e08._instance;
    }
    start() {
        this.loc = new (0, $ae8a3c12e902894e$export$30e2160809baa85b)((0, $ae8a3c12e902894e$export$ce4fe1c9e6520c1a).PtBr);
        this.audioManager = new (0, $147779db9aa8deb0$export$557a8016f4e0c1ba)();
        this.bagManager = new (0, $514d467852c05e06$export$36eb8cca929288cd)();
        this.characterManager = new (0, $ea43a44514016353$export$5f400b495260ae4b)();
        this.characterManager.start();
        this.eventManager = new (0, $cbb58ac183868e7d$export$cc74486daaaef499)();
        this.gameOverManager = new (0, $fc8f23560e9fa5ff$export$e6f377c5bf36ff9f)();
        this.skillCheckManager = new (0, $9e93b9db2423d7df$export$ee498bc1e428f957)();
        this.ripManager = new (0, $dfe474540f60039a$export$63ed3fcf5e5b0cca)();
        this.mapManager = new (0, $1b9b55c6f4e5d90c$export$c521bb0b406df9a3)();
        this.logManager = new (0, $9c7a2a4f88c432f6$export$49b118289be48034)();
        this.stateManager = new (0, $4b7b87bfcd759858$export$4d5c8163a511d38a)();
        this.itemPickerManager = new (0, $4ac31c89200f3453$export$3dc9b393db657566)();
        this.introManager = new (0, $efaa3735b04f10d5$export$21ea51713927a803)();
        this.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).INTRO);
    }
    get log() {
        return this.logManager;
    }
    get characters() {
        return this.characterManager.characters;
    }
}


const $b4e14b6b8da86996$var$game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
$b4e14b6b8da86996$var$game.start();
window.__game = $b4e14b6b8da86996$var$game;
const $b4e14b6b8da86996$var$getVisiblePageId = ()=>{
    const pages = [
        [
            'intro',
            $b4e14b6b8da86996$var$game.pages.intro
        ],
        [
            'log',
            $b4e14b6b8da86996$var$game.pages.log
        ],
        [
            'event',
            $b4e14b6b8da86996$var$game.pages.event
        ],
        [
            'skillCheck',
            $b4e14b6b8da86996$var$game.pages.skillCheck
        ],
        [
            'gameOver',
            $b4e14b6b8da86996$var$game.pages.gameOver
        ],
        [
            'rip',
            $b4e14b6b8da86996$var$game.pages.rip
        ],
        [
            'bag',
            $b4e14b6b8da86996$var$game.pages.bag
        ],
        [
            'itemPicker',
            $b4e14b6b8da86996$var$game.pages.itemPicker
        ],
        [
            'map',
            $b4e14b6b8da86996$var$game.pages.map
        ]
    ];
    const visibleEntry = pages.find(([, page])=>page.style.display !== 'none');
    return visibleEntry ? visibleEntry[0] : null;
};
const $b4e14b6b8da86996$var$getTextList = (selector)=>{
    return Array.from(document.querySelectorAll(selector)).map((node)=>(node.textContent || '').trim()).filter(Boolean);
};
window.advanceTime = (ms)=>{
    return new Promise((resolve)=>{
        window.setTimeout(resolve, Math.max(0, ms));
    });
};
window.render_game_to_text = ()=>{
    const visiblePage = $b4e14b6b8da86996$var$getVisiblePageId();
    const visibleButtons = Array.from(document.querySelectorAll('button')).filter((button)=>button.offsetParent !== null).map((button)=>({
            text: (button.textContent || '').trim(),
            disabled: button.disabled,
            id: button.id || null
        }));
    const payload = {
        coordinateSystem: 'DOM UI only; top-left origin; no gameplay canvas is used.',
        visiblePage: visiblePage,
        state: {
            currentState: $b4e14b6b8da86996$var$game.stateManager.currentState,
            currentDay: $b4e14b6b8da86996$var$game.state.currentDay,
            currentHour: $b4e14b6b8da86996$var$game.state.clock.currentHour,
            anteMeridiem: $b4e14b6b8da86996$var$game.state.clock.anteMeridiem,
            currentMapNodeId: $b4e14b6b8da86996$var$game.state.currentMapNodeId,
            exploredLocationsCount: $b4e14b6b8da86996$var$game.state.exploredLocationsCount,
            pendingExplorationVictory: $b4e14b6b8da86996$var$game.state.pendingExplorationVictory,
            isVictoryEnding: $b4e14b6b8da86996$var$game.state.isVictoryEnding
        },
        characters: $b4e14b6b8da86996$var$game.characters.map((character)=>({
                name: character.name,
                kinship: character.kinship,
                sanity: character.sanity,
                isDead: character.isDead,
                buried: character.buried,
                afflictions: character.showAfflictions()
            })),
        visibleButtons: visibleButtons,
        headings: $b4e14b6b8da86996$var$getTextList('h1, h2'),
        paragraphs: $b4e14b6b8da86996$var$getTextList('p'),
        logEntries: $b4e14b6b8da86996$var$getTextList('#log-list-result li'),
        bagItems: $b4e14b6b8da86996$var$getTextList('#bag-item-list li'),
        itemsToPick: $b4e14b6b8da86996$var$getTextList('#item-picker-page-items-to-pick li'),
        myItems: $b4e14b6b8da86996$var$getTextList('#item-picker-page-item-my-items li'),
        mapNodes: $b4e14b6b8da86996$var$getTextList('.map-node-label'),
        choiceButtons: $b4e14b6b8da86996$var$getTextList('#event-page-choices-btn-list button')
    };
    return JSON.stringify(payload, null, 2);
};


//# sourceMappingURL=get-out.25f282cf.js.map
